import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

var Cookies = require('js-cookie');

// Ready translated locale messages
const messages = {
    sv: {

        countryCode: 'SV',
        yes: 'ja',
        no: 'nej',
        abort: 'avbryt',
        my: 'mina',
        done: 'klar',
        pick: 'välj',
        save: 'spara',
        share: 'dela',
        buy: 'köp',
        addToCart: 'Lägg i',
        name: 'Namn',
        currencySuffix: ' kr',
        currencySuffixBuy: ':-',
        currencyPrefix: '',
        frameYourMotifs: 'Rama in dina motiv',

        background: 'miljöbild | miljöbilder',
        picturewall: 'tavelvägg | tavelväggar',
        backgroundColor: 'bakgrundsfärg | bakgrundsfärger',
        color: 'färg | färger',
        motifs: 'motiv | motiv',

        clear: 'Rensa',

        filter: 'Filter',
        showFilter: 'Visa filter',
        hideFilter: 'Dölj filter',
        clearFilter: 'Rensa filter',
        category: 'Kategori',

        allArticles: 'Alla',
        articles: 'artiklar',

        clickToPickMotif: 'Klicka på en tavla i tavelväggen för att välja motiv.',
        clickToPickWall: 'Välj en tavelvägg innan du väljer motiv',

        turnDevice: 'Vänd på din enhet',
        swipeUp: 'Swipa uppåt',

        waresAddedToCart: 'Dina varor har lagts i varukorgen',
        proceedingToCheckout: 'Tar dig vidare till kassan',
        saveBasket: 'Spara tavelväggen',
        noSavedWalls: 'Inga sparade tavelväggar',
        updateOrnew: 'Du har valt en sparad tavelvägg som heter {name}, vill du uppdatera befintlig eller skapa en ny sparning? ',
        createNew: 'skapa ny',
        update: 'uppdatera',

        shareTitle: 'Dela din tavelvägg',

        shareSaveTitle: 'Du måste spara först',
        shareSaveText: 'Du måste spara din tavelvägg innan du kan dela den, vill du spara tavelväggen nu?',

        errorTitle: 'Något gick fel.',
        errorMessage: 'Ett tekniskt fel uppstod, var god försök igen eller kontakta support.',
        showMore: 'Visa fler',
        showLess: 'Visa mindre',
        noProductsInBasket: 'Var god välj minst en produkt att lägga i varukorgen.',
        removeTitle: 'Ta bort tavelvägg',
        removePromt: 'Är du säker på att du vill ta bort tavelväggen?',
        couldNotRemove: 'Kunde inte ta bort, var god försök igen eller kontakta support.',
        remove: 'Ta bort',
        removeFrame: 'Ta bort ram',
        close: 'Stäng',
        wantToContinue: 'Vill du fortsätta?',
        unsavedChanges: 'Du har osparade ändringar som går förlorade om du fortsätter, vill du spara din tavelvägg nu?',

        needsArticlesShare: 'Var god lägg till minst en artikel innan du delar.',
        needsArticlesSave: 'Var god lägg till minst en artikel innan du sparar.',
        needsPictureWall: 'Var god välj en tavelvägg innan du väljer artiklar.',

        menu: 'Meny',

        noMotivs: 'Du har inte valt några motiv',

        leavingSave: 'Du har inte sparat din tavelvägg, vill du lämna?',

        addedToCartDate: 'Lagd i varukorg {date}',

        saveAndMoveOn: 'Nästa',
        moveOn: 'Nästa',
        saveAndClose: 'Spara och stäng',

        backgrounds: '1. Välj miljöbild',
        pictureWalls: '2. Välj tavelvägg',
        yourMotifs: '3. Välj motiv',
        frames: '4. Rama in dina motiv',

        leftToFreeShipping: 'Kvar till fri frakt',
        checkout: 'Kassan',
        total: 'totalsumma',

        emptyBasket: 'Du har inte lagt några produkter i varukorgen.',
        allProducts: 'Alla produkter',
        lastViewed: 'Senast visade',
        myFavorites: 'Mina favoriter',
        lastChosen: 'Senast valda',
        choosePictureWallBeforeFrames: 'Var god välj en tavelvägg innan du väljer ram.',

        dontSave: "spara inte",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Använd hjärtsymbolen för att spara dina favoriter. <br/> Visa favoriter i rullistan uppe till vänster.',
        purchaseNowTitle: 'Vad fint det blev!',
        purchaseNow: 'Du kan lägga hela din tavelvägg i varukorgen här.',
        addToCart: 'Lägg i',
        addToCartSmall: 'Lägg i',
        toCheckout: 'Till kassan',
        savedWalls: 'Sparade tavelväggar',
        goBackToStep: 'Föregående',

        favoritesThatMatch: 'Favoriter som finns i vald storlek',
        favoritesThatMatchMobile: 'Favoriter i vald storlek',

        noStock: 'Några varor är slut i lager.',

        startTop: 'Steg-för-steg',
        startTitle: 'Skapa den perfekta tavelväggen',
        startText: 'Använd vårt nya verktyg för att hitta motiv och ramar som matchar med varandra.',
        startButton: 'BÖRJA HÄR',
        clickFullscreen: 'Klicka för att starta fullskärm',

        noArticlesMatched: 'Tyvärr finns inte några artiklar i storleken  <b> {size} </b> som matchar dina val',
        breadcrumbPrints: 'Tavlor',
        breadcrumbInsp: 'Inspiration',
        breadcrumbInspLink: 'https://desenio.se/g/tavelvaggar/',
        breadcrumbGw: 'Bygg din tavelvägg',
        breadcrumbGwLink: 'https://gwt.desenio.se/#/',

        linkToWall: 'Länk till din tavelvägg',
        copy: 'Kopiera',

        outOfStock: 'Slut i lager',
        outOfStockText: 'Artiklarna nedan är slut i lager, du kan bevaka artiklarna för att bli notifierad när de återkommer i lager. ',

        checkoutUrl: 'https://checkout.desenio.se',
        pageUrl: 'https://desenio.se',

    },

    no: {
        countryCode: 'NO',
        yes: 'ja',
        no: 'nei',
        abort: 'avbryt',
        my: 'mine',
        done: 'ferdig',
        pick: 'velg',
        save: 'lagre',
        share: 'del',
        buy: 'kjøp',
        addToCart: 'Legg til',
        name: 'Navn',
        currencySuffix: ' ,-',
        currencySuffixBuy: ',-',
        currencyPrefix: '',
        frameYourMotifs: 'Ram inn motivene dine',
        background: 'miljøbilde | miljøbilder',
        picturewall: 'bildevegg | bildevegger',
        backgroundColor: 'bakgrunnsfarge | bakgrunnsfarger',
        color: 'farge | farger',
        motifs: 'motiv | motiver',
        clear: 'Tøm',
        filter: 'Filter',
        showFilter: 'Vis filter',
        hideFilter: 'Skjul filter',
        clearFilter: 'Tøm filter',
        category: 'Kategori',
        allArticles: 'Alle',
        articles: 'artikler',
        clickToPickMotif: 'Klikk på et bilde på bildeveggen for å velge motiv.',
        clickToPickWall: 'Velg en bildevegg før du velger motiv',
        turnDevice: 'Snu enheten din',
        swipeUp: 'Sveip opp',
        waresAddedToCart: 'Varene er lagt i handlekurven',
        proceedingToCheckout: 'Tar deg videre til kassen',
        saveBasket: 'Lagre bildeveggen',
        noSavedWalls: 'Ingen lagrede bildevegger',
        updateOrnew: 'Du har valgt en lagret bildevegg som heter {name}. Vil du oppdatere eksisterende eller opprette en ny utgave? ',
        createNew: 'opprett ny',
        update: 'oppdater',
        shareTitle: 'Del bildeveggen din',
        shareSaveTitle: 'Du må lagre først',
        shareSaveText: 'Du må lagre bildeveggen før du kan dele den. Vil du lagre bildeveggen nå?',
        errorTitle: 'Noe gikk galt.',
        errorMessage: 'Det oppstod en teknisk feil. Prøv på nytt, eller kontakt kundestøtte.',
        showMore: 'Vis flere',
        showLess: 'Vis færre',
        noProductsInBasket: 'Velg minst ett produkt som skal legges i handlekurven.',
        removeTitle: 'Slett bildevegg',
        removePromt: 'Vil du slette bildeveggen?',
        couldNotRemove: 'Kunne ikke slette. Prøv på nytt, eller kontakt brukerstøtte.',
        remove: 'Fjern',
        removeFrame: 'Fjern ramme',
        close: 'Lukk',
        wantToContinue: 'Vil du fortsette?',
        unsavedChanges: 'Du har endringer som ikke er lagret. Disse går tapt hvis du fortsetter. Vil du lagre bildeveggen nå?',
        needsArticlesShare: 'Legg til minst én artikkel før du deler.',
        needsArticlesSave: 'Legg til minst én artikkel før du lagrer.',
        needsPictureWall: 'Velg en bildevegg før du velger artikler.',
        menu: 'Meny',
        noMotivs: 'Du har ikke valgt noen motiver',
        leavingSave: 'Du har ikke lagret bildeveggen din. Vil du avslutte?',
        addedToCartDate: 'Lagt i handlekurv {date}',
        saveAndMoveOn: 'Neste',
        moveOn: 'Neste',
        saveAndClose: 'Lagre og lukk',
        backgrounds: '1. Velg miljøbilde',
        pictureWalls: '2. Velg bildevegg',
        yourMotifs: '3. Velg motiv',
        frames: '4. Ram inn motivene dine',
        leftToFreeShipping: 'Unna gratis frakt',
        checkout: 'Kassen',
        total: 'sum',
        emptyBasket: 'Du har ikke lagt noen produkter i handlekurven.',
        allProducts: 'Alle produkter',
        lastViewed: 'Sist vist',
        myFavorites: 'Mine favoritter',
        lastChosen: 'Sist valgt',
        choosePictureWallBeforeFrames: 'Velg en bildevegg før du velger ramme.',
        dontSave: "ikke lagre",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Bruk hjertesymbolet til å lagre favorittene dine. <br/> Vis favoritter i rullelisten øverst til venstre.',
        purchaseNowTitle: 'Så fint det ble!',
        purchaseNow: 'Du kan legge hele bildeveggen i handlekurven her.',
        addToCart: 'Legg til',
        addToCartSmall: 'Legg til',
        toCheckout: 'Kassen',
        savedWalls: 'Lagrede bildevegger',
        goBackToStep: 'Forrige',
        favoritesThatMatch: 'Favoritter som finnes i valgt størrelse',
        favoritesThatMatchMobile: 'Favoritter i valgt størrelse',
        noStock: 'Noen varer er utsolgt.',

        startTop: 'Steg-för-steg',
        startTitle: 'Skap den perfekte bildeveggen',
        startText: 'Bruk det nye verktøyet vårt for å finne motiver og rammer som passer sammen.',
        startButton: 'START HER',
        clickFullscreen: 'Klikk for fullskjerm',

        noArticlesMatched: 'Vi kan dessverre ikke finne et produkt som matcher din søkning',
        breadcrumbPrints: 'Plakater',
        breadcrumbInsp: 'Inspirasjon ',
        breadcrumbInspLink: 'https://desenio.no/g/bildevegger/',
        breadcrumbGw: 'Lag din bildevegg',
        breadcrumbGwLink: 'https://gwt.desenio.no/',

        linkToWall: 'LINK TIL DIN BILDEVEGG',
        copy: 'Kopier',

        outOfStock: 'Utsolgt',
        outOfStockText: 'Varene nedenfor er utsolgt, du kan overvåke varene som skal varsles når de kommer tilbake på lager.',

        checkoutUrl: 'https://checkout.desenio.no',
        pageUrl: 'https://desenio.no',

    },
    fi: {
        countryCode: 'FI',
        yes: 'kyllä',
        no: 'ei',
        abort: 'keskeytä',
        my: 'minun',
        done: 'valmis',
        pick: 'valitse',
        save: 'tallenna',
        share: 'jaa',
        buy: 'osta',
        addToCart: 'Lisää',
        name: 'Nimi',
        currencySuffix: ' &euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Kehystä aiheesi',
        background: 'ympäristökuva | ympäristökuvat',
        picturewall: 'tauluseinä | tauluseinät',
        backgroundColor: 'taustaväri | taustavärit',
        color: 'väri | värit',
        motifs: 'aihe | aiheet',
        clear: 'Poista',
        filter: 'Suodatin',
        showFilter: 'Näytä suodatin',
        hideFilter: 'Piilota suodatin',
        clearFilter: 'Poista suodatin',
        category: 'Luokka',
        allArticles: 'Kaikki',
        articles: 'tuotteet',
        clickToPickMotif: 'Napsauta taulua tauluseinällä valitaksesi aiheen.',
        clickToPickWall: 'Valitse tauluseinä ennen aiheen valintaa',
        turnDevice: 'Käännä yksikköä',
        swipeUp: 'Pyyhkäise ylös',
        waresAddedToCart: 'Tuotteesi on lisätty ostoskoriin',
        proceedingToCheckout: 'Jatka kassalle',
        saveBasket: 'Tallenna tauluseinä',
        noSavedWalls: 'Ei tallennettuja tauluseiniä',
        updateOrnew: 'Olet valinnut tauluseinän {nimi}. Haluatko päivittää nykyistä vai luoda uuden tallennettavaksi? ',
        createNew: 'luo uusi',
        update: 'päivitä',
        shareTitle: 'Jaa tauluseinäsi',
        shareSaveTitle: 'Tallenna ensin',
        shareSaveText: 'Sinun on tallennettava tauluseinäsi voidaksesi jakaa sen. Haluatko tallentaa tauluseinän nyt?',
        errorTitle: 'Jokin meni vikaan.',
        errorMessage: 'Tapahtui tekninen virhe. Yritä uudelleen tai ota yhteys tukeen.',
        showMore: 'Näytä lisää',
        showLess: 'Näytä vähemmän',
        noProductsInBasket: 'Valitse vähintään yksi tuote lisättäväksi ostoskoriin.',
        removeTitle: 'Poista tauluseinä',
        removePromt: 'Haluatko varmasti poistaa tauluseinän?',
        couldNotRemove: 'Poistaminen ei onnistunut. Yritä uudelleen tai ota yhteys tukeen.',
        remove: 'Poista',
        removeFrame: 'Poista kehys',
        close: 'Sulje',
        wantToContinue: 'Haluatko jatkaa?',
        unsavedChanges: 'Jos jatkat tallentamatta, muutokset poistetaan. Haluatko tallentaa tauluseinäsi nyt?',
        needsArticlesShare: 'Lisää ainakin yksi tuote, ennen kuin voit jakaa.',
        needsArticlesSave: 'Lisää ainakin yksi tuote, ennen kuin voit tallentaa.',
        needsPictureWall: 'Valitse tauluseinä ennen tuotteiden valintaa,',
        menu: 'Valikko',
        noMotivs: 'Et ole valinnut aiheita',
        leavingSave: 'Et ole tallentanut tauluseinääsi, haluatko silti poistua?',
        addedToCartDate: 'Lisätty ostoskoriin {date}',
        saveAndMoveOn: 'Seuraava vaihe',
        moveOn: 'Seuraava vaihe',
        saveAndClose: 'Tallenna ja sulje',
        backgrounds: '1. Valitse ympäristökuva',
        pictureWalls: '2. Valitse tauluseinä',
        yourMotifs: '3. Valitse aihe',
        frames: '4. Kehystä aiheesi',
        leftToFreeShipping: 'Jäljellä ilmaiseen kuljetukseen',
        checkout: 'Kassa',
        total: 'kokonaissumma',
        emptyBasket: 'Ostoskorisi on tyhjä.',
        allProducts: 'Kaikki tuotteet',
        lastViewed: 'Viimeksi katsellut',
        myFavorites: 'Omat suosikkini',
        lastChosen: 'Viimeksi valitut',
        choosePictureWallBeforeFrames: 'Valitse tauluseinä ennen kehysten valintaa,',
        dontSave: "älä tallenna",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Vinkkejä ',
        heartInfo: 'Tallenna sydänkuvakkeella suosikkisi. <br/> Näytä suosikit vieritysvalikossa vasemmalla ylhäällä.',
        purchaseNowTitle: 'Tulipa siitä hieno!',
        purchaseNow: 'Voit lisätä koko tauluseinäsi ostoskoriin tästä.',
        addToCartSmall: 'Lisää',
        toCheckout: 'Kassa',
        savedWalls: 'Tallennetut tauluseinät',
        goBackToStep: 'Edellinen vaihe',
        favoritesThatMatch: 'Suosikit, joita on saatavana valittuna kokona',
        favoritesThatMatchMobile: 'Suosikit valittuna kokona',
        noStock: 'Jotkin tuotteet ovat loppuneet varastosta.',

        startTop: 'Askel askeleelta',
        startTitle: 'Luo täydellinen tauluseinä',
        startText: 'Käytä uutta työkaluamme löytääksesi yhteensopivat aiheet ja kehykset',
        startButton: 'ALOITA TÄSTÄ',
        clickFullscreen: 'Klikkaa tästä',

        noArticlesMatched: 'Pahoittelut, emme löydä tuotteita koossa (size), jotka vastaavat hakuasi',
        breadcrumbPrints: 'Tauluja',
        breadcrumbInsp: 'Inspiraatiojulisteet',
        breadcrumbInspLink: 'https://desenio.fi/g/tauluseinat/',
        breadcrumbGw: 'Rakenna tauluseinäsi',
        breadcrumbGwLink: 'https://gwt.desenio.fi/',

        linkToWall: 'LINKKI TAULUSEINÄÄSI',
        copy: 'Kopioi',

        outOfStock: 'Ei varastossa',
        outOfStockText: 'Alla olevat tuotteet ovat loppu, voit seurata tuotteita ja saada ilmoituksen, kun ne tulevat takaisin varastoon.',

        checkoutUrl: 'https://checkout.desenio.fi',
        pageUrl: 'https://desenio.fi',

    },
    dk: {
        countryCode: 'DK',
        yes: 'ja',
        no: 'nej',
        abort: 'afbryd',
        my: 'mine',
        done: 'udført',
        pick: 'vælg',
        save: 'gem',
        share: 'del',
        buy: 'køb',
        addToCart: 'Læg til',
        name: 'Navn',
        currencySuffix: ' kr.',
        currencySuffixBuy: ':-',
        currencyPrefix: '',
        frameYourMotifs: 'Indram dine motiver',
        background: 'miljøbillede | miljøbilleder',
        picturewall: 'billedvæg | billedvægge',
        backgroundColor: 'baggrundsfarve | baggrundsfarver',
        color: 'farve | farver',
        motifs: 'motiv | motiver',
        clear: 'Ryd',
        filter: 'Filter',
        showFilter: 'Vis filter',
        hideFilter: 'Skjul filter',
        clearFilter: 'Ryd filter',
        category: 'Kategori',
        allArticles: 'Alle',
        articles: 'varer',
        clickToPickMotif: 'Klik på et billede på billedvæggen for at vælge motiv.',
        clickToPickWall: 'Vælg en billedvæg, inden du vælger motiv',
        turnDevice: 'Vend din enhed',
        swipeUp: 'Swipe opad',
        waresAddedToCart: 'Dine varer er lagt i indkøbsvognen',
        proceedingToCheckout: 'Gå videre til kassen',
        saveBasket: 'Gem billedvæggen',
        noSavedWalls: 'Der er ingen gemte billedvægge',
        updateOrnew: 'Du har valgt en gemt billedvæg kaldet {name}. Vil du opdatere den eksisterende eller oprette en ny, der skal gemmes? ',
        createNew: 'opret ny',
        update: 'opdater',
        shareTitle: 'Del din billedvæg',
        shareSaveTitle: 'Du skal gemme først',
        shareSaveText: 'Du skal gemme din billedvæg, før du kan dele den. Vil du gemme billedvæggen nu?',
        errorTitle: 'Der gik noget galt.',
        errorMessage: 'Der opstod en teknisk fejl. Prøv igen, eller kontakt support.',
        showMore: 'Vis flere',
        showLess: 'Vis mindre',
        noProductsInBasket: 'Du skal vælge mindst ét produkt, der skal lægges i indkøbsvognen.',
        removeTitle: 'Slet billedvæg',
        removePromt: 'Er du sikker på, at du vil slette billedvæggen?',
        couldNotRemove: 'Det var ikke muligt at slette. Prøv igen, eller kontakt support.',
        remove: 'Slet',
        removeFrame: 'Slet ramme',
        close: 'Luk',
        wantToContinue: 'Vil du fortsætte?',
        unsavedChanges: 'Der er ændringer, der ikke er gemt. De går tabt, hvis du fortsætter. Vil du gemme billedvægen nu?',
        needsArticlesShare: 'Tilføj mindst én vare, før du deler.',
        needsArticlesSave: 'Tilføj mindst én vare, før du gemmer.',
        needsPictureWall: 'Vælg en billedvæg, inden du vælger varer.',
        menu: 'Menu',
        noMotivs: 'Du har ikke valgt nogen motiver',
        leavingSave: 'Du har ikke gemt billedvæggen. Vil du afslutte?',
        addedToCartDate: 'Lagt i indkøbsvogn {date}',
        saveAndMoveOn: 'Næste',
        moveOn: 'Næste',
        saveAndClose: 'Gem og luk',
        backgrounds: '1. Vælg miljøbillede',
        pictureWalls: '2. Vælg billedvæg',
        yourMotifs: '3. Vælg motiv',
        frames: '4. Indram dine motiver',
        leftToFreeShipping: 'Tilbage indtil gratis fragt',
        checkout: 'Til kassen',
        total: 'i alt',
        emptyBasket: 'Du har ikke lagt nogen produkter i indkøbsvognen.',
        allProducts: 'Alle produkter',
        lastViewed: 'Sidst viste',
        myFavorites: 'Mine favoritter',
        lastChosen: 'Sidst valgte',
        choosePictureWallBeforeFrames: 'Vælg en billedvæg, inden du vælger ramme.',
        dontSave: "gem ikke",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Brug hjerteikonet til at gemme dine favoritter. <br/> Få vist favoritter i rullelisten øverst til venstre.',
        purchaseNowTitle: 'Hvor er det flot!',
        purchaseNow: 'Du kan lægge hele din billedvæg i indkøbsvognen her.',
        addToCart: 'Læg til',
        addToCartSmall: 'Læg til',
        toCheckout: 'Til kassen',
        savedWalls: 'Gemte billedvægge',
        goBackToStep: 'Forrige',
        favoritesThatMatch: 'Favoritter, der findes i den valgte størrelse',
        favoritesThatMatchMobile: 'Favoritter i valgt størrelse',
        noStock: 'Nogle af varerne er ikke på lager.',

        startTop: 'Trin for trin',
        startTitle: 'Skab den perfekte billedvæg',
        startText: 'Brug vores nye værktøj til at finde motiver og rammer, der passer sammen.',
        startButton: 'BEGYND HER',
        clickFullscreen: 'Klik for fuldskærm',

        noArticlesMatched: 'Vi kan desværre ikke finde et produkt i (størrelse) som matcher din søgning.',
        breadcrumbPrints: 'Posters',
        breadcrumbInsp: 'Inspiration',
        breadcrumbInspLink: 'https://desenio.dk/g/billedvaeg/',
        breadcrumbGw: 'Byg din billedvæg',
        breadcrumbGwLink: 'https://gwt.desenio.dk/',

        linkToWall: 'Link til dit væg galleri',
        copy: 'Kopier',

        outOfStock: 'Ikke på lager',
        outOfStockText: 'Nedenstående varer er ikke på lager, du kan overvåge varerne for at få besked, når de kommer på lager igen.',

        checkoutUrl: 'https://checkout.desenio.dk',
        pageUrl: 'https://desenio.dk',

    },
    en: {
        countryCode: 'EN',
        yes: 'yes',
        no: 'no',
        abort: 'cancel',
        my: 'my',
        done: 'done',
        pick: 'select',
        save: 'save',
        share: 'share',
        buy: 'buy',
        addToCart: 'Add to',
        name: 'Name',
        currencySuffix: '',
        currencySuffixBuy: '',
        currencyPrefix: '£',
        frameYourMotifs: 'Frame your designs',
        background: 'background | backgrounds',
        picturewall: 'picture wall | picture walls',
        backgroundColor: 'background colour | background colours',
        color: 'colour | colours',
        motifs: 'design | designs',
        clear: 'Clear',
        filter: 'Filter',
        showFilter: 'Show filter',
        hideFilter: 'Hide filter',
        clearFilter: 'Clear filter',
        category: 'Category',
        allArticles: 'All',
        articles: 'articles',
        clickToPickMotif: 'Click on a picture on the picture wall to select a design.',
        clickToPickWall: 'Select a picture wall before selecting designs',
        turnDevice: 'Turn your device',
        swipeUp: 'Swipe up',
        waresAddedToCart: 'Your items have been added to the cart',
        proceedingToCheckout: 'Proceed to checkout',
        saveBasket: 'Save picture wall',
        noSavedWalls: 'No saved picture walls',
        updateOrnew: 'You have selected a saved picture wall {name}. Would you like to update your wall or create a new one? ',
        createNew: 'create new',
        update: 'update',
        shareTitle: 'Share your picture wall',
        shareSaveTitle: 'Please save first',
        shareSaveText: 'You must save your picture wall before you can share it. Would you like to save your picture wall now?',
        errorTitle: 'Something went wrong.',
        errorMessage: 'A technical problem has occurred. Please try again or contact our support service.',
        showMore: 'Show more',
        showLess: 'Show less',
        noProductsInBasket: 'Please select at least one product to add to your cart.',
        removeTitle: 'Delete picture wall',
        removePromt: 'Are you sure you want to delete your picture wall?',
        couldNotRemove: 'Unable to delete. Please try again or contact our support service.',
        remove: 'Delete',
        removeFrame: 'Delete frame',
        close: 'Close',
        wantToContinue: 'Would you like to continue?',
        unsavedChanges: 'You have made changes that have not been saved. Would you like to save your picture wall now?',
        needsArticlesShare: 'Please add at least one item before sharing.',
        needsArticlesSave: 'Please add at least one item before saving.',
        needsPictureWall: 'Please select a picture wall before selecting items.',
        menu: 'Menu',
        noMotivs: 'You have not selected any designs',
        leavingSave: 'You have not saved your picture wall. Are you sure you want to leave?',
        addedToCartDate: 'Added to cart {date}',
        saveAndMoveOn: 'Next',
        moveOn: 'Next',
        saveAndClose: 'Save and close',
        backgrounds: '1. Select background',
        pictureWalls: '2. Select picture wall',
        yourMotifs: '3. Select designs',
        frames: '4. Frame your designs',
        leftToFreeShipping: 'Needed for free shipping',
        checkout: 'Checkout',
        total: 'total amount',
        emptyBasket: 'You have not added any products to your cart.',
        allProducts: 'All products',
        lastViewed: 'Last viewed',
        myFavorites: 'My favourites',
        lastChosen: 'Last selected',
        choosePictureWallBeforeFrames: 'Please select a picture wall before selecting frames.',
        dontSave: "don't save",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
        heartInfo: 'Click the heart symbol to save your favourites. <br/> Show favourites in the drop-down list to the left.',
        purchaseNowTitle: 'That looks great!',
        purchaseNow: 'You can add your whole picture wall to your cart here.',
        addToCart: 'Add to',
        addToCartSmall: 'Add to',
        toCheckout: 'Checkout',
        savedWalls: 'Saved gallery walls',
        goBackToStep: 'Previous',
        favoritesThatMatch: 'Favourites available in the selected size',
        favoritesThatMatchMobile: 'Favourites in the selected size',
        noStock: 'Some items are out of stock.',

        startTop: 'Step-by-step',
        startTitle: 'Create the perfect gallery wall',
        startText: 'Use our new tool to find designs and frames that match each other',
        startButton: 'START HERE',
        clickFullscreen: 'Click for fullscreen',

        noArticlesMatched: "Sorry, we can't find any products in (size) that match your search.",
        breadcrumbPrints: 'Wall art',
        breadcrumbInsp: 'Inspiration',
        breadcrumbInspLink: 'https://desenio.co.uk/g/gallery-walls/',
        breadcrumbGw: 'Create your gallery wall',
        breadcrumbGwLink: 'https://gwt.desenio.co.uk/#/',

        linkToWall: 'YOUR GALLERY WALL LINK',
        copy: 'Copy',

        outOfStock: 'Out of stock',
        outOfStockText: 'The items below are out of stock, you can monitor the items to be notified when they are back in stock.',

        checkoutUrl: 'https://checkout.desenio.co.uk',
        pageUrl: 'https://desenio.co.uk',

    },
    nl: {
        countryCode: 'NL',
        yes: 'ja',
        no: 'nee',
        abort: 'annuleren',
        my: 'mijn',
        done: 'klaar',
        pick: 'selecteren',
        save: 'opslaan',
        share: 'delen',
        buy: 'kopen',
        addToCart: 'In',
        name: 'Naam',
        currencySuffix: ' ',
        currencySuffixBuy: '',
        currencyPrefix: '&euro;',
        frameYourMotifs: 'Lijst uw motieven in',
        background: 'contextuele foto | contextuele foto‘s',
        picturewall: 'fotowand | fotowanden',
        backgroundColor: 'achtergrondkleur | achtergrondkleuren',
        color: 'kleur | kleuren',
        motifs: 'motief | motieven',
        clear: 'Wissen',
        filter: 'Filter',
        showFilter: 'Filter weergeven',
        hideFilter: 'Filter verbergen',
        clearFilter: 'Filter wissen',
        category: 'Categorie',
        allArticles: 'Alle',
        articles: 'artikelen',
        clickToPickMotif: 'Klik op een foto in de fotowand om een motief te kiezen.',
        clickToPickWall: 'Kies een fotowand voordat u een motief kiest',
        turnDevice: 'Draai uw apparaat om',
        swipeUp: 'Veeg omhoog',
        waresAddedToCart: 'Uw artikelen zijn in het winkelmandje geplaatst',
        proceedingToCheckout: 'Ga verder naar de kassa',
        saveBasket: 'Sla de fotowand op',
        noSavedWalls: 'Geen opgeslagen fotowanden',
        updateOrnew: 'U heeft een opgeslagen fotowand gekozen, die {name} heet, wilt u deze bijwerken of een opslaan als een nieuwe fotowand? ',
        createNew: 'nieuwe maken',
        update: 'bijwerken',
        shareTitle: 'Uw fotowand delen',
        shareSaveTitle: 'U moet eerst opslaan',
        shareSaveText: 'U moet uw fotowand opslaan voordat u hem kunt delen. Wilt u de fotowand nu opslaan?',
        errorTitle: 'Er is iets misgegaan.',
        errorMessage: 'Er is een technische storing opgetreden. Probeer het opnieuw of neem contact op met support.',
        showMore: 'Meer weergeven',
        showLess: 'Minder weergeven',
        noProductsInBasket: 'Selecteer ten minste één product om aan uw winkelmandje toe te voegen.',
        removeTitle: 'Fotowand verwijderen',
        removePromt: 'Weet u zeker dat u de fotowand wilt verwijderen?',
        couldNotRemove: 'Kon niet verwijderen, probeer het opnieuw of neem contact op met support.',
        remove: 'Verwijderen',
        removeFrame: 'Lijst verwijderen',
        close: 'Sluiten',
        wantToContinue: 'Wilt u verdergaan?',
        unsavedChanges: 'U heeft nog niet opgeslagen wijzigingen die verloren gaan als u verdergaat. Wilt u uw fotowand nu opslaan?',
        needsArticlesShare: 'Er moet ten minste een artikel zijn toegevoegd voordat u kunt delen.',
        needsArticlesSave: 'Er moet ten minste een artikel zijn toegevoegd voordat u kunt opslaan.',
        needsPictureWall: 'Kies een fotowand voordat u artikelen kiest.',
        menu: 'Menu',
        noMotivs: 'U heeft geen motieven geselecteerd',
        leavingSave: 'U heeft uw fotowand niet opgeslagen, wilt u stoppen?',
        addedToCartDate: 'Aan winkelmandje toegevoegd {date}',
        saveAndMoveOn: 'Volgende',
        moveOn: 'Volgende',
        saveAndClose: 'Opslaan en sluiten',
        achtergronden: '1. Selecteer contextuele foto',
        pictureWalls: '2. Selecteer fotowand',
        yourMotifs: '3. Selecteer motieven',
        frames: '4. Lijst uw motieven in',
        leftToFreeShipping: 'Nog te gaan tot gratis verzending',
        checkout: 'Kassa',
        total: 'totaal bedrag',
        emptyBasket: 'U heeft geen producten in het winkelmandje gelegd.',
        allProducts: 'Alle producten',
        lastViewed: 'Laatst bekeken',
        myFavorites: 'Mijn favorieten',
        lastChosen: 'Laatst geselecteerd',
        choosePictureWallBeforeFrames: 'Selecteer een fotowand voordat u lijsten kiest.',
        dontSave: "niet opslaan",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tip ',
        heartInfo: 'Gebruik het hart-pictogram om uw favorieten op te slaan. <br/> Geef uw favorieten weer in de drop-downlijst in de linker bovenhoek.',
        purchaseNowTitle: 'O, wat mooi!',
        purchaseNow: 'U kunt uw complete fotowand hier in het winkelmandje plaatsen.',
        addToCart: 'In',
        addToCartSmall: 'In',
        toCheckout: 'Kassa',
        savedWalls: 'Bewaarde posterwanden',
        goBackToStep: 'Vorige',
        favoritesThatMatch: 'Favorieten die verkrijgbaar zijn in de geselecteerde grootte',
        favoritesThatMatchMobile: 'Favorieten in geselecteerde grootte',
        noStock: 'Enkele artikelen zijn niet op voorraad.',

        startTop: 'Stap-voor-stap',
        startTitle: 'Maak de perfecte fotowand',
        startText: 'Gebruik onze nieuwe tool om motieven en lijsten te vinden die bij elkaar passen',
        startButton: 'START HIER',
        clickFullscreen: 'Klik voor volledig scherm',

        noArticlesMatched: 'Er zijn helaas geen artikelen in formaat (size) die overeenkomen met jouw zoekopdracht.',
        breadcrumbPrints: 'Posters',
        breadcrumbInsp: 'INSPIRATIE',
        breadcrumbInspLink: 'https://desenio.nl/g/fotowanden/',
        breadcrumbGw: 'Stel uw fotowand samen',
        breadcrumbGwLink: 'https://gwt.desenio.nl/',

        linkToWall: 'LINK NAAR JE FOTOWAND',
        copy: 'Kopieer',

        outOfStock: 'Niet op voorraad',
        outOfStockText: 'De onderstaande artikelen zijn niet op voorraad, u kunt de artikelen volgen om een bericht te krijgen wanneer ze weer op voorraad zijn.',

        checkoutUrl: 'https://checkout.desenio.nl',
        pageUrl: 'https://desenio.nl',

    },
    fr: {
        countryCode: 'FR',
        yes: 'oui',
        no: 'non',
        abort: 'annuler',
        my: 'mes',
        done: 'terminé',
        pick: 'CHOISISSEZ',
        save: 'enregistrer',
        share: 'partager',
        buy: 'acheter',
        addToCart: 'AJOUTER AU',
        name: 'Nom',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Encadrez vos affiches',
        background: "un fond | des fonds",
        picturewall: 'UN MUR DE CADRES| DES MURS DE CADRES',
        backgroundColor: 'couleur de fond | couleurs de fond',
        color: 'couleur | couleurs',
        motifs: 'UNE AFFICHE | DES AFFICHES',
        clear: 'Vider',
        filter: 'Filtre',
        showFilter: 'Montrer le filtre',
        hideFilter: 'Cacher le filtre',
        clearFilter: 'Vider le filtre',
        category: 'Catégorie',
        allArticles: 'Tous les articles',
        articles: 'articles',
        clickToPickMotif: 'Cliquez sur un tableau dans le mur de tableaux pour sélectionner un motif.',
        clickToPickWall: 'Sélectionnez un mur de tableaux avant de sélectionner un motif',
        turnDevice: 'Tournez votre appareil',
        swipeUp: "Balayez l'écran vers le haut",
        waresAddedToCart: "Vos articles ont été mis dans le panier",
        proceedingToCheckout: 'Allez à la caisse',
        saveBasket: 'Enregistrer le mur de tableaux',
        noSavedWalls: "Aucun mur de tableaux n'est enregistré",
        updateOrnew: "Vous avez choisi un mur de tableaux enregistré qui s'appelle {name}. Voulez-vous le mettre à jour ou en créer un nouveau ?",
        createNew: 'Créer un nouveau',
        update: 'mettre à jour',
        shareTitle: 'Partagez votre mur de tableaux',
        shareSaveTitle: "Vous devez d'abord enregistrer",
        shareSaveText: "Vous devez enregistrer votre mur de tableaux avant de le partager. Voulez-vous l'enregistrer maintenant ?",
        errorTitle: "Une erreur s'est produite.",
        errorMessage: "Une erreur technique s'est produite, essayez de nouveau ou contactez le service d'assistance.",
        showMore: 'Montrer plus',
        showLess: 'Montrer moins',
        noProductsInBasket: 'Veuillez sélectionner au moins un produit à ajouter dans le panier.',
        removetitle: 'Supprimer le mur de tableaux',
        removePromt: 'Êtes-vous certain de vouloir supprimer le mur de tableaux ?',
        couldNotRemove: "Suppression impossible, essayez de nouveau ou contactez le service d'assistance.",
        remove: 'Supprimer',
        removeFrame: 'Supprimer le cadre',
        close: 'Fermer',
        wantToContinue: 'Voulez-vous continuer ?',
        unsavedChanges: 'Vous avez des modifications non enregistrées qui seront perdues si vous continuez. Voulez-vous enregistrer votre mur de tableaux maintenant ?',
        needsArticlesShare: 'Veuillez ajouter au moins un article avant de partager.',
        needsArticlesSave: 'Veuillez ajouter au moins un article avant de sauvegarder.',
        needsPictureWall: 'Sélectionnez un mur de tableaux avant de sélectionner des articles.',
        menu: 'Menu',
        noMotivs: 'Vous n’avez sélectionné aucun motif',
        leavingSave: 'Vous n’avez pas enregistré votre mur de tableaux ; voulez-vous quitter?',
        addedToCartDate: 'Ajouté au panier {date}',
        saveAndMoveOn: 'suivant',
        moveOn: 'suivant',
        saveAndClose: 'Enregistrer et fermer',
        backgrounds: '1. Choisissez un fond',
        pictureWalls: '2. Choisissez un mur de cadres',
        yourMotifs: '3. Choisissez une affiche',
        frames: '4. Encadrez vos affiches',
        leftToFreeShipping: 'Ce qui manque pour bénéficier de la livraison gratuite',
        checkout: 'PANIER',
        total: 'total',
        emptyBasket: 'Vous n’avez ajouté aucun produit à votre panier.',
        allProducts: 'Tous les produits',
        lastViewed: 'Derniers regardés',
        myFavorites: 'Mes favoris',
        lastChosen: 'Derniers sélectionnés',
        choosePictureWallBeforeFrames: 'Sélectionnez un mur de tableaux avant de choisir les cadres.',
        dontSave: 'ne pas enregistrer',
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Conseils ',
        heartInfo: 'Utilisez le symbole de c&#x153;ur pour sauvegarder vos favoris. <Br/> Affichez les favoris dans la liste déroulante dans le coin supérieur gauche.',
        purchaseNowTitle: 'Comme c&#x2019;est beau !',
        purchaseNow: 'Vous pouvez mettre tout votre mur de tableaux dans le panier ici.',
        addToCart: 'Ajouter au',
        addToCartSmall: 'Ajouter au',
        toCheckout: 'PANIER',
        savedWalls: 'MURS DE CADRES SAUVEGARDÉS',
        goBackToStep: 'PRÉCÉDENT',
        favoritesThatMatch: 'Favoris disponibles dans la taille sélectionnée',
        favoritesThatMatchMobile: 'Favoris dans la taille sélectionnée',
        noStock: 'Certains articles sont en rupture de stock.',

        startTop: "Étape par étape",
        startTitle: 'Créez le mur de tableaux parfait',
        startText: 'Utilisez notre nouvel outil pour trouver des affiches et des cadres qui vont bien ensemble',
        startButton: 'COMMENCEZ ICI',
        clickFullscreen: 'Klik voor volledig scherm',

        noArticlesMatched: 'Désolé, nous ne trouvons pas de produits en (taille) correspondant à vos critères de recherche',
        breadcrumbPrints: 'Tableaux',
        breadcrumbInsp: 'INSPIRATION',
        breadcrumbInspLink: 'https://desenio.fr/g/decoration-murale/',
        breadcrumbGw: 'Créez votre mur de cadres',
        breadcrumbGwLink: 'https://gwt.desenio.fr/#/',

        linkToWall: 'LIEN DE VOTRE MUR DE CADRES',
        copy: 'Copier',

        outOfStock: 'En rupture de stock',
        outOfStockText: 'Les articles ci-dessous sont en rupture de stock, vous pouvez surveiller les articles pour être informé de leur retour en stock.',

        checkoutUrl: 'https://checkout.desenio.fr',
        pageUrl: 'https://desenio.fr',

    },
    es: {
        countryCode: 'ES',
        yes: 'si',
        no: 'no',
        abort: 'cancelar',
        my: 'mis',
        done: 'listo',
        pick: 'elegir',
        save: 'guardar',
        share: 'compartir',
        buy: 'comprar',
        addToCart: 'Añadir a',
        name: 'Nombre',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Enmarca tus motivos',
        background: 'entorno | entornos',
        picturewall: 'decoración de pared | decoración de pared',
        backgroundColor: 'color de fondo | colores de fondo',
        color: 'color | colores',
        motifs: 'póster | pósters',
        clear: 'Eliminar',
        filter: 'Filtros',
        showFilter: 'Mostrar filtro',
        hideFilter: 'Ocultar filtro',
        clearFilter: 'Eliminar filtro',
        category: 'Categoría',
        allArticles: 'Todos',
        articles: 'artículos',
        clickToPickMotif: 'Haz clic en un cuadro de la pared de decoración para elegir el motivo.',
        clickToPickWall: 'Elige una decoración de pared antes de elegir el motivo',
        turnDevice: 'Dale la vuelta a tu dispositivo',
        swipeUp: 'Desplázate hacia arriba',
        waresAddedToCart: 'Hemos añadido tus productos a la cesta de la compra',
        proceedingToCheckout: 'Te lleva a la caja',
        saveBasket: 'Guardar la decoración de pared',
        noSavedWalls: 'No hay decoraciones de pared guardadas',
        updateOrnew: 'Has elegido una decoración de pared guardada que se llama {name}, ¿quieres actualizar la existente o crear una nueva?',
        createNew: 'crear nueva',
        update: 'actualizar',
        shareTitle: 'Comparte tu decoración de pared',
        shareSaveTitle: 'Debes guardarla primero',
        shareSaveText: 'Debes guardar tu decoración de pared antes de poder compartirla. ¿Deseas guardar la decoración de pared ahora?',
        errorTitle: 'Se ha producido un error.',
        errorMessage: 'Se ha producido un error técnico. Inténtalo de nuevo o ponte en contacto con el servicio técnico.',
        showMore: 'Mostrar más',
        showLess: 'Mostrar menos',
        noProductsInBasket: 'Por favor selecciona al menos un producto para añadir a la cesta de la compra.',
        removeTitle: 'Eliminar la decoración de pared',
        removePromt: '¿Estás seguro de querer eliminar la decoración de pared?',
        couldNotRemove: 'No se ha podido eliminar. Inténtalo de nuevo o ponte en contacto con el servicio técnico.',
        remove: 'Eliminar',
        removeFrame: 'Eliminar marco',
        close: 'Cerrar',
        wantToContinue: '¿Deseas continuar?',
        unsavedChanges: 'Has hecho cambios que no has guardado y que se perderán si continúas. ¿Deseas guardar tu decoración de pared ahora?',
        needsArticlesShare: 'Añade al menos un artículo antes de compartir',
        needsArticlesSave: 'Añade al menos un artículo antes de guardar.',
        needsPictureWall: 'Selecciona una decoración de pared antes de elegir artículos',
        menu: 'Menú',
        noMotivs: 'No has seleccionado ningún motivo',
        leavingSave: 'No has guardado tu decoración de pared.¿Deseas salir?',
        addedToCartDate: 'Añadido a la cesta de la compra {fecha}',
        saveAndMoveOn: 'Siguiente',
        moveOn: 'Siguiente',
        saveAndClose: 'Guardar y cerrar',
        backgrounds: "1 'Elige foto de la naturaleza",
        pictureWalls: "2 'Elige decoración de pared",
        yourMotifs: '3. Elige motivo',
        frames: '4. Enmarca tus pósters',
        leftToFreeShipping: 'Importe restante para que los portes sean gratuitos',
        checkout: 'Ir a la caja',
        total: 'Importe total',
        emptyBasket: 'No has añadido ningún producto a la cesta de la compra.',
        allProducts: 'Todos los productos',
        lastViewed: 'Último producto visto',
        myFavorites: 'Mis favoritos',
        lastChosen: 'Última selección',
        choosePictureWallBeforeFrames: 'Selecciona una decoración de pared antes de elegir el marco.',
        dontSave: "no guardar",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Consejos ',
        heartInfo: 'Utiliza el icono del corazón para guardar tus favoritos. <br/> Muestra los favoritos en la barra de desplazamiento en la parte superior izquierda.',
        purchaseNowTitle: '¡Qué bonito te ha quedado!',
        purchaseNow: 'Añade toda tu decoración de pared a la cesta de la compra aquí',
        addToCart: 'Añadir a',
        addToCartSmall: 'Añadir a',
        toCheckout: 'Ir a la caja',
        savedWalls: 'Galerías guardadas',
        goBackToStep: 'Anterior',
        favoritesThatMatch: 'Favoritos que encontrarás en el tamaño elegido',
        favoritesThatMatchMobile: 'Favoritos en el tamaño elegido',
        noStock: 'Algunos artículos están agotados.',

        startTop: "Paso-a-paso",
        startTitle: 'Crea la decoración de pared perfecta',
        startText: 'Utiliza nuestra nueva herramienta para encontrar motivos y marcos que combinen entre sí',
        startButton: 'EMPIEZA AQUÍ',
        clickFullscreen: 'Haga clic para pantalla completa',

        noArticlesMatched: 'Lo sentimos, no podemos encontrar ningún producto en el (tamaño) que coincida con sus criterios de búsqueda',
        breadcrumbPrints: 'Cuadros',
        breadcrumbInsp: 'INSPIRACIÓN',
        breadcrumbInspLink: 'https://desenio.es/g/galerias-de-pared/',
        breadcrumbGw: 'Crea tu decoración de pared',
        breadcrumbGwLink: 'https://gwt.desenio.es/#/',

        linkToWall: 'ENLACE PARA SU MURAL DE CUADROS',
        copy: 'Copiar',

        outOfStock: 'Agotado',
        outOfStockText: 'Los artículos que aparecen a continuación están agotados, puede ver los artículos para que se le informe cuando vuelvan a estar en stock.',

        checkoutUrl: 'https://checkout.desenio.es',
        pageUrl: 'https://desenio.es',

    },
    us: window.localeUS,
    de: {
        countryCode: 'DE',
        yes: 'Ja',
        no: 'Nein',
        abort: 'Abbrechen',
        my: 'meine',
        done: 'fertig',
        pick: 'auswählen',
        save: 'speichern',
        share: 'teilen',
        buy: 'kaufen',
        addToCart: 'In den',
        name: 'Name',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Rahme deine Motive ein',
        background: 'Umgebungsbild | Umgebungsbilder',
        picturewall: 'Bilderwand | Bilderwände',
        backgroundColor: 'Hintergrundfarbe | Hintergrundfarben',
        color: 'Farbe | Farben',
        motifs: 'Motiv | Motive',
        clear: 'Löschen',
        filter: 'Filter',
        showFilter: 'Filter einblenden',
        hideFilter: 'Filter ausblenden',
        clearFilter: 'Filter aufheben',
        category: 'Kategorie',
        allArticles: 'Alle',
        articles: 'Artikel',
        clickToPickMotif: 'Klicke auf ein Bild in der Bilderwand, um ein Motiv auszuwählen.',
        clickToPickWall: 'Vor der Auswahl von Motiven eine Bilderwand auswählen',
        turnDevice: 'Das Gerät drehen',
        swipeUp: 'Nach oben wischen',
        waresAddedToCart: 'Deine Artikel wurden dem Warenkorb hinzugefügt',
        proceedingToCheckout: 'Zur Kasse gehen',
        saveBasket: 'Bilderwand speichern',
        noSavedWalls: 'Keine gespeicherten Bilderwände',
        updateOrnew: 'Du hast bereits eine Bilderwand, die unter dem Namen {name} gespeichert ist, möchtest du die vorhandene Bilderwand aktualisieren oder eine neue anlegen?',
        createNew: 'neu erstellen',
        update: 'aktualisieren',
        shareTitle: 'Deine Bilderwand teilen',
        shareSaveTitle: 'Du musst zuerst speichern',
        shareSaveText: 'Vor dem Teilen musst du deine Bilderwand speichern. Möchtest du die Bilderwand jetzt teilen?',
        errorTitle: 'Ein Fehler ist aufgetreten.',
        errorMessage: 'Ein Fehler ist aufgetreten, bitte versuche es erneut oder wende dich an den Support.',
        showMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        noProductsInBasket: 'Bitte wähle mindestens einen Artikel für den Warenkorb aus.',
        removeTitle: 'Bilderwand entfernen',
        removePromt: 'Möchtest du die Bilderwand wirklich entfernen?',
        couldNotRemove: 'Entfernen fehlgeschlagen, bitte versuche es erneut oder wende dich an den Support.',
        remove: 'Entfernen',
        removeFrame: 'Rahmen entfernen',
        close: 'Schließen',
        wantToContinue: 'Möchtest du fortfahren?',
        unsavedChanges: 'Es gibt Änderungen, die nicht gespeichert wurden und verloren gehen, wenn du fortfährst. Möchtest du deine Bilderwand jetzt speichern?',
        needsArticlesShare: 'Vor dem Teilen bitte mindestens einen Artikel hinzufügen.',
        needsArticlesSave: 'Vor dem Speichern bitte mindestens einen Artikel hinzufügen.',
        needsPictureWall: 'Vor der Auswahl von Artikeln bitte eine Bilderwand auswählen.',
        menu: 'Menü',
        noMotivs: 'Du hast keine Motive ausgewählt',
        leavingSave: 'Du hast deine Bilderwand nicht gespeichert, möchtest du die Seite wirklich verlassen?',
        addedToCartDate: 'Dem Warenkorb hinzugefügt am {date}',
        saveAndMoveOn: 'Weiter',
        moveOn: 'Weiter',
        saveAndClose: 'Speichern und schließen',
        backgrounds: '1. Umgebungsbild auswählen',
        pictureWalls: '2. Bilderwand auswählen',
        yourMotifs: '3. Motiv auswählen',
        frames: '4. Rahme deine Motive ein',
        leftToFreeShipping: 'bis zum kostenlosen Versand',
        checkout: 'Zur Kasse',
        total: 'Gesamt',
        emptyBasket: 'Du hast keine Artikel zum Warenkorb hinzugefügt.',
        allProducts: 'Alle Produkte',
        lastViewed: 'Zuletzt angesehen',
        myFavorites: 'Meine Favoriten',
        lastChosen: 'Zuletzt ausgewählt',
        choosePictureWallBeforeFrames: 'Vor der Auswahl von Rahmen bitte eine Bilderwand auswählen.',
        dontSave: "nicht speichern",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tipp',
        heartInfo: 'Mit dem Herzsymbol kannst du deine Favoriten speichern. <br/>Favoriten in der Dropdown-Liste oben links anzeigen.',
        purchaseNowTitle: 'Gratuliere, toll geworden!',
        purchaseNow: 'Hier kannst du deine komplette Bilderwand zum Warenkorb hinzufügen.',
        addToCart: 'In den',
        addToCartSmall: 'In den',
        toCheckout: 'Zur Kasse',
        savedWalls: 'Gespeicherte Bilderwände',
        goBackToStep: 'Zurück',
        favoritesThatMatch: 'In der ausgewählten Größe verfügbare Favoriten',
        favoritesThatMatchMobile: 'Favoriten in der ausgewählten Größe',
        noStock: 'Einige Artikel sind ausverkauft.',

        startTop: "Schritt-für-Schritt",
        startTitle: 'Komponiere die perfekte Bilderwand',
        startText: 'Verwende unser neues Tool, um Motive und Rahmen zu finden, die zueinander passen',
        startButton: 'HIER STARTEN',
        clickFullscreen: 'Klick für Vollbild',

        noArticlesMatched: 'Leider können wir keine Produkte in der Größe (size) finden, die deinen Suchkriterien entsprechen.',
        breadcrumbPrints: 'Wandbilder',
        breadcrumbInsp: 'INSPIRATION',
        breadcrumbInspLink: 'https://desenio.de/g/bilderwande/',
        breadcrumbGw: 'Komponiere deine Bilderwand',
        breadcrumbGwLink: 'https://gwt.desenio.de/#/',

        linkToWall: 'LINK ZU DEINER POSTERWAND',
        copy: 'Kopieren',

        checkoutUrl: 'https://checkout.desenio.de',
        pageUrl: 'https://desenio.de',

    },
    it: {
        countryCode: 'IT',
        yes: 'sì',
        no: 'no',
        abort: 'annulla',
        my: 'mio',
        done: 'fatto',
        pick: 'seleziona',
        save: 'salva',
        share: 'condividi',
        buy: 'acquista',
        addToCart: 'Aggiungi al',
        name: 'Nome',
        currencySuffix: ' &euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Incornicia i tuoi poster',
        background: 'soggetto naturale | soggetti naturali',
        picturewall: 'galleria | gallerie',
        backgroundColor: 'colore di sfondo | colori di sfondo',
        color: 'colore | colori',
        motifs: 'soggetto | soggetti',
        clear: 'Cancella',
        filter: 'Filtro',
        showFilter: 'mostra filtro',
        hideFilter: 'Nascondi filtro',
        clearFilter: 'Elimina filtro',
        category: 'Categoria',
        allArticles: 'Tutti',
        articles: 'articoli',
        clickToPickMotif: 'Clicca su un poster della galleria per selezionare il soggetto.',
        clickToPickWall: 'Seleziona una galleria prima di scegliere un soggetto',
        turnDevice: 'Gira il dispositivo',
        swipeUp: 'Scorri in alto',
        waresAddedToCart: 'I tuoi articoli sono stati aggiunti al carrello',
        proceedingToCheckout: 'Procedi alla cassa',
        saveBasket: 'Salva la galleria',
        noSavedWalls: 'Nessuna galleria salvata',
        updateOrnew: 'È stata selezionata una galleria salvata di nome {name}, si desidera aggiornare la galleria esistente o crearne una nuova? ',
        createNew: 'crea nuova',
        update: 'aggiorna',
        shareTitle: 'Condividi la galleria',
        shareSaveTitle: 'È necessario salvare prima',
        shareSaveText: 'È necessario salvare la galleria prima di condividerla. Desideri salvare la galleria ora?',
        errorTitle: 'Si è verificato un errore. ',
        errorMessage: 'Si è verificato un errore tecnico. Riprovare o contattare l’assistenza.',
        showMore: 'Mostra altri',
        showLess: 'Mostra meno',
        noProductsInBasket: 'Selezionare almeno un articolo da aggiungere al carrello.',
        removeTitle: 'Rimuovi la galleria',
        removePromt: 'Sei sicuro di che voler rimuovere la galleria?',
        couldNotRemove: 'Non è stato possibile rimuovere. Riprovare o contattare l’assistenza.',
        remove: 'Rimuovi',
        removeFrame: 'Rimuovi la cornice',
        close: 'Chiudi',
        wantToContinue: 'Si desidera continuare?',
        unsavedChanges: 'Sono state apportate modifiche non salvate che andranno perse se si continua. Salvare la galleria adesso? ',
        needsArticlesShare: 'Aggiungere almeno un articolo prima di condividere.',
        needsArticlesSave: 'Aggiungere almeno un articolo prima di salvare.',
        needsPictureWall: 'Selezionare una galleria prima di scegliere un articolo',
        menu: 'Menu',
        noMotivs: 'Non è stato selezionato alcun soggetto',
        leavingSave: 'La galleria non è stata salvata. Vuoi uscire? ',
        addedToCartDate: 'Aggiunto al carrello {data}',
        saveAndMoveOn: 'PROSSIMO STEP',
        moveOn: 'PROSSIMO STEP',
        saveAndClose: 'Salva e chiudi',
        backgrounds: '1. Selezionare un soggetto naturale',
        pictureWalls: '2. Selezionare una galleria di immagini',
        yourMotifs: '3. Selezionare un soggetto',
        frames: '4. Incorniciare i poster',
        leftToFreeShipping: 'Manca alla spedizione gratuita',
        checkout: 'VAI ALLA CASSA',
        total: 'totale',
        emptyBasket: 'Il carrello non contiene articoli.',
        allProducts: 'Tutti i prodotti',
        lastViewed: 'Ultimi visualizzati',
        myFavorites: 'I miei preferiti',
        lastChosen: 'Ultime scelte',
        choosePictureWallBeforeFrames: 'Selezionare una galleria prima di scegliere una cornice',
        dontSave: "non salvare",
        heartInfoTitle: '<a class="fa fa-heart-o"></i> Suggerimenti </a>',
        heartInfo: "Selezionare l'icona a forma di cuore per salvare i preferiti. <br/> Visualizzare i preferiti nell'elenco a discesa in alto a sinistra.",
        purchaseNowTitle: 'Che bello!',
        purchaseNow: 'Qui è possibile aggiungere l’intera galleria al carrello.',
        addToCart: 'Aggiungi al',
        addToCartSmall: 'Aggiungi al',
        toCheckout: 'VAI ALLA CASSA',
        savedWalls: 'GALLERIE A PARETE SALVATE',
        goBackToStep: 'PRECEDENTE STEP',
        favoritesThatMatch: 'Preferiti disponibili nel formato selezionato',
        favoritesThatMatchMobile: 'Preferiti nel formato selezionato',
        noStock: 'Alcuni articoli sono esauriti.',

        startTop: "Passo-per-passo",
        startTitle: 'Crea una perfetta galleria di immagini',
        startText: 'Usa il nostro nuovo strumento per trovare soggetti e cornici che stanno bene insieme',
        startButton: 'INIZIA QUI',
        clickFullscreen: 'Clicca per schermo intero',

        noArticlesMatched: 'Scusaci, non troviamo i prodotti della( misura) che hai selezionato',
        breadcrumbPrints: 'Quadri',
        breadcrumbInsp: 'ISPIRAZIONE',
        breadcrumbInspLink: 'https://desenio.it/g/gallerie-a-parete/',
        breadcrumbGw: 'Crea la tua galleria a parete',
        breadcrumbGwLink: 'https://gwt.desenio.it/#/',

        linkToWall: 'IL LINK DELLA TUA GALLERIA A PARETE',
        copy: 'Copia',

        outOfStock: 'Nicht mehr auf Lager',
        outOfStockText: 'Die folgenden Artikel sind nicht mehr auf Lager, Sie können die Artikel beobachten, um informiert zu werden, wenn sie wieder auf Lager sind.',

        checkoutUrl: 'https://checkout.desenio.it',
        pageUrl: 'https://desenio.it',
    },
    pt: {
        countryCode: 'PT',
        yes: 'sim',
        no: 'não',
        abort: 'cancelar',
        my: 'meu/minha',
        done: 'concluído',
        pick: 'escolha',
        save: 'guardar',
        share: 'partilhar',
        buy: 'comprar',
        addToCart: 'Adicionar a',
        name: 'Nome',
        currencySuffix: '&euro;',
        currencySuffixBuy: '&euro;',
        currencyPrefix: '',
        frameYourMotifs: 'Emoldure os seus temas',
        background: 'imagem do ambiente | imagens do ambiente',
        picturewall: ' parede de quadros | paredes de quadros',
        backgroundColor: 'cor de fundo | cores de fundo',
        color: 'cor | cores',
        motifs: 'tema | temas',
        clear: 'Apagar',
        filter: 'Filtro',
        showFilter: 'Mostrar filtro',
        hideFilter: 'Ocultar filtro',
        clearFilter: 'Limpar filtro',
        category: 'Categoria',
        allArticles: 'Todos',
        articles: 'artigos',
        clickToPickMotif: 'Clique num quadro da parede de quadros para escolher o tema.',
        clickToPickWall: 'Escolha a parede de quadros antes de escolher o tema',
        turnDevice: 'Vire a sua unidade ao contrário',
        swipeUp: 'Passe o dedo e faça um swipe para cima',
        waresAddedToCart: 'Os seus artigos foram adicionados ao carrinho de compras',
        proceedingToCheckout: 'Vai levá-lo até à caixa',
        saveBasket: 'Guardar a parede de quadros',
        noSavedWalls: 'Não tem paredes de quadros guardadas',
        updateOrnew: 'Escolheu uma parede de quadros guardada designada {name}; quer atualizar esta ou criar uma nova para guardar?',
        createNew: 'criar nova',
        update: 'atualizar',
        shareTitle: 'Partilhe a sua parede de quadros',
        shareSaveTitle: 'Deve primeiro guardar',
        shareSaveText: 'É necessário guardar a sua parede de quadros antes de a poder partilhar; quer guardar agora a sua parede de quadros?',
        errorTitle: 'Ocorreu algum erro',
        errorMessage: 'Ocorreu um erro técnico, por favor tente novamente ou entre em contacto com os serviços de apoio.',
        showMore: 'Mostrar mais',
        showLess: 'Mostrar menos',
        noProductsInBasket: 'Por favor escolha pelo menos um produto para adicionar ao carrinho de compras.',
        removeTitle: 'Remover a parede de quadros',
        removePromt: 'Tem a certeza que pretende remover a parede de quadros?',
        couldNotRemove: 'Não foi possível remover, por favor tente novamente ou entre em contacto com os serviços de apoio.',
        remove: 'Remover',
        removeFrame: 'Remover moldura',
        close: 'Fechar',
        wantToContinue: 'Gostaria de continuar?',
        unsavedChanges: 'Tem alterações não guardadas que vai perder se continuar; quer guardar agora a sua parede de quadros?',
        needsArticlesShare: 'Por favor adicione pelo menos um artigo antes de partilhar.',
        needsArticlesSave: 'Por favor adicione pelo menos um artigo antes de guardar.',
        needsPictureWall: 'Por favor escolha uma parede de quadros antes de escolher os artigos',
        menu: 'Menu',
        noMotivs: 'Não escolheu um tema',
        leavingSave: 'Não guardou a sua parede de quadros; quer sair? ',
        addedToCartDate: 'Adicionado ao carrinho {date}',
        saveAndMoveOn: 'Passo seguinte',
        MoveOn: 'Passo seguinte',
        saveandclose: 'Guardar e fechar',
        backgrounds: '1. Escolha a imagem de ambiente',
        pictureWalls: '2. Selecione a parede de quadros',
        yourMotifs: '3. Escolha o tema',
        frames: '4. Emoldure os seus temas',
        leftToFreeShipping: 'Restante que falta até ter o transporte gratuito',
        checkout: 'Para a caixa',
        total: 'soma total',
        emptyBasket: 'Não adicionou produtos ao seu carrinho.',
        allProducts: 'Todos os produtos',
        lastViewed: 'Últimos visualizados',
        myFavorites: 'Os meus favoritos',
        lastChosen: 'Últimos selecionados',
        choosePictureWallBeforeFrames: 'Por favor escolha a parede de quadros antes de escolher a moldura',
        dontSave: "não guardar",
        heartInfoTitle: '<na classe="fa fa-heart-o"></i> Sugestões ',
        heartInfo: 'Usar o símbolo do coração para guardar os seus favoritos. <br/> Ver os favoritos na lista drop-down no canto superior esquerdo.',
        purchaseNowTitle: 'Que bem que ficou!',
        purchaseNow: 'Pode adicionar ao carrinho toda a sua parede de quadros aqui.',
        addToCart: 'Adicionar a',
        addToCartSmall: 'Adicionar a',
        toCheckout: 'Para a caixa',
        savedWalls: 'Paredes de quadros guardadas',
        goBackToStep: 'Passo anterior',
        favoritesThatMatch: 'Favoritos disponíveis no tamanho selecionado',
        favoritesThatMatchMobile: 'Favoritos no tamanho selecionado',
        noStock: 'Alguns dos artigos estão esgotados.',

        startTop: "Passo-a-passo",
        startTitle: 'Crie a parede de quadros perfeita',
        startText: 'Use a nossa nova ferramenta para encontrar os temas e molduras que ficam bem',
        startButton: 'INICIAR AQUI',
        clickFullscreen: 'Clique para tela cheia',

        noArticlesMatched: 'Lamentamos mas não encontramos produtos do (tamanho) que correspondam à sua busca.',
        breadcrumbPrints: 'Quadros',
        breadcrumbInsp: 'INSPIRAÇÃO',
        breadcrumbInspLink: 'https://desenio.pt/g/paredes-de-quadros/',
        breadcrumbGw: 'Crie a sua parede de quadros',
        breadcrumbGwLink: 'https://gwt.desenio.pt/#/',

        linkToWall: 'LINK PARA A SUA PAREDE DE QUADROS',
        copy: 'Copiar',

        outOfStock: 'Out of stock',
        outOfStockText: 'The items below are out of stock, you can watch the items to be informed when they are back in stock',

        checkoutUrl: 'https://checkout.desenio.pt',
        pageUrl: 'https://desenio.pt',

    },
    pl: {
        countryCode: 'PL',
        yes: 'tak',
        no: 'nie',
        abort: 'anuluj',
        my: 'moje',
        done: 'koniec',
        pick: 'wybierz',
        save: 'zachowaj',
        share: 'udostępnij',
        buy: 'kup',
        addToCart: 'Dodaj do',
        name: 'Imię',
        currencySuffix: 'zł',
        currencySuffixBuy: 'zł',
        currencyPrefix: '',
        frameYourMotifs: 'Opraw swoje grafiki',
        background: 'tło | tła',
        picturewall: 'galeria domowa | galerie domowe',
        backgroundColor: 'kolor tła | kolory tła',
        color: 'kolor| kolory',
        motifs: 'projekt| projekty',
        clear: 'wyczyść',
        filter: 'filtry',
        showFilter: 'pokaż filtry',
        hideFilter: 'Ukryj filtry',
        clearFilter: 'Wyczyść filtry',
        category: 'Kategoria',
        allArticles: 'Wszystko',
        articles: 'produkty',
        clickToPickMotif: 'Kliknij na print w galerii ściennej żeby wybrać design.',
        clickToPickWall: 'Wybierz galerię przed wybraniem printu',
        turnDevice: 'Odwróć swoje urządzenie',
        swipeUp: 'Przesuń do góry',
        waresAddedToCart: 'Twoje produkty zostały dodane do koszyka',
        proceedingToCheckout: 'Przejdź do płatności',
        saveBasket: 'Zachowaj galerię',
        noSavedWalls: 'Brak zachowanych galerii',
        updateOrnew: 'Wybrałeś zachowaną galerię {nazwa}. Chcesz zmienić projekt, lub stworzyć nową galerię?  ',
        createNew: 'Stwórz nową',
        update: 'Zmień',
        shareTitle: 'Udostępnij swoją galerię plakatów',
        shareSaveTitle: 'Najpierw zachowaj projekt',
        shareSaveText: 'Musisz zachować projekt galerii przed udostępnieniem. Chcesz zachować galerię?',
        errorTitle: 'Coś poszło nie tak.',
        errorMessage: 'Przepraszamy, problem techniczny. Spróbuj jeszcze raz, lub skontaktuj się z nami.',
        showMore: 'Więcej',
        showLess: 'Mniej',
        noProductsInBasket: 'Wybierz przynajmniej jeden produkt do koszyka',
        removeTitle: 'Wymaż projekt galerii',
        removePromt: 'Na pewno chcesz wymazać projekt galerii plakatów?',
        couldNotRemove: 'Nie można wymazać. Spróbuj jeszcze raz, lub skontaktuj się z nami.',
        remove: 'Wymaż',
        removeFrame: 'Wymaż ramkę',
        close: 'Zamknij',
        wantToContinue: 'Chcesz kontynuować?',
        unsavedChanges: 'Twoje zmiany nie zostały zapisane. Chcesz zapisać swój projekt galeri ściennej?',
        needsArticlesShare: 'Dodaj przynajmniej jeden element przed udostępnieniem.',
        needsArticlesSave: 'Dodaj przynajmniej jeden element przed zapisaniem.',
        needsPictureWall: 'Wybierz projekt galerii zanim wybierzesz produkty',
        menu: 'Menu',
        noMotivs: 'Nie wybrano żadnych projektów',
        leavingSave: 'Twój projekt galerii nie został zapisany, czy chcesz zamknąć bez zapisywania?',
        addedToCartDate: 'Dodane do koszyka {data}',
        saveAndMoveOn: 'Dalej',
        moveOn: 'Dalej',
        saveAndClose: 'Zapisz i zamknij',
        backgrounds: '1. Wybierz tło',
        pictureWalls: '2. Wybierz galerię',
        yourMotifs: '3. Wybierz grafiki',
        frames: '4. Opraw swoje plakaty',
        leftToFreeShipping: 'Do darmowej przesyłki brakuje',
        checkout: 'Koszyk',
        total: 'Cena całkowita',
        emptyBasket: 'Żadne produkty nie zostały wybrane do koszyka.',
        allProducts: 'Wszystkie produkty',
        lastViewed: 'Ostatnio oglądane',
        myFavorites: 'Moje ulubione',
        lastChosen: 'Ostatnio wybrane',
        choosePictureWallBeforeFrames: 'Wybierz projekt galerii przed wybraniem ramek.',
        dontSave: "nie zapisuj",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Wskazówki',
        heartInfo: 'Kliknij na ikonkę serca, żeby zapisać artykuły do ulubionych. <br/> Wyświetl swoje ulubione produkty rozwijając listę po lewej stronie',
        purchaseNowTitle: 'Wygląda wspaniale!',
        purchaseNow: 'Tutaj dodasz cały Twój projekt galerii z plakatami do koszyka',
        addToCart: 'Dodaj do',
        addToCartSmall: 'Dodaj do',
        toCheckout: 'Koszyk',
        savedWalls: 'Zapisane projekty galerii',
        goBackToStep: 'Wstecz',
        favoritesThatMatch: 'Ulubione dostępne są w wybranych rozmiarach',
        favoritesThatMatchMobile: 'Ulubione w wybranych rozmiarach',
        noStock: 'Niektóre produkty są wyprzedane.',

        startTop: 'Krok po kroku',
        startTitle: 'Stwórz perfekcyjną domową galerię',
        startText: 'Skorzystaj z naszego nowego narzędzia, aby znaleźć pasujące grafiki i ramki',
        startButton: 'ZACZNIJ TUTAJ',
        clickFullscreen: 'Pełny ekran',

        noArticlesMatched: 'Przepraszamy, niestety nie znaleźliśmy żadnych produktów w tym (rozmiarze)',
        breadcrumbPrints: 'Plakaty',
        breadcrumbInsp: 'INSPIRACJE',
        breadcrumbInspLink: 'https://desenio.pl/g/galeria-obrazow/',
        breadcrumbGw: 'Stwórz swoją domową galerię',
        breadcrumbGwLink: 'https://gwt.desenio.pl/#/',

        linkToWall: 'LINK DO TWOJEJ GALERII',
        copy: 'Kopiuj',

        outOfStock: 'Na wyczerpaniu zapasów',
        outOfStockText: 'Poniższe produkty są niedostępne w magazynie, możesz je obserwować, aby być informowanym o ich dostępności.',

        checkoutUrl: 'https://checkout.desenio.pl',
        pageUrl: 'https://desenio.pl',

    },
    cs: {
        countryCode: 'CS',
        yes: 'ano',
        no: 'ne',
        abort: 'zrušit',
        my: 'můj',
        done: 'hotovo',
        pick: 'vybrat',
        save: 'uložit',
        share: 'sdílet',
        buy: 'koupit',
        addToCart: 'Přidat do',
        name: 'Jméno',
        currencySuffix: ' Kč',
        currencySuffixBuy: ' Kč',
        currencyPrefix: '',
        frameYourMotifs: 'Orámuj si svůj design',
        background: 'pozadí | pozadí',
        picturewall: 'koláž | koláže',
        backgroundColor: 'barva pozadí | barvy pozadí',
        color: 'barva | barvy',
        motifs: 'návrh | návrhy',
        clear: 'Vymazat',
        filter: 'Filtr',
        showFilter: 'Zobrazit filtr',
        hideFilter: 'Skrýt filtr',
        clearFilter: 'Vymazat filtr',
        category: 'Kategorie',
        allArticles: 'Všechny',
        articles: 'položky',
        clickToPickMotif: 'Pro výběr designu klikněte na obrázek na koláži.',
        clickToPickWall: 'Vyberte koláž, než vyberete návrhy.',
        turnDevice: 'Otočte zařízení',
        swipeUp: 'Posuňte nahoru',
        waresAddedToCart: 'Vaše položky byly přidány do košíku',
        proceedingToCheckout: 'Přejít k pokladně',
        saveBasket: 'Uložit koláž.',
        noSavedWalls: 'Žádné uložené koláže.',
        updateOrnew: 'Vybrali jste uloženou koláž {název}. Chcete aktualizovat svou koláž nebo vytvořit novou? ',
        createNew: 'vytvořit novou',
        update: 'aktualizovat',
        shareTitle: 'Sdílet svou koláž.',
        shareSaveTitle: 'Nejprve uložte.',
        shareSaveText: 'Před sdílením je třeba koláž uložit. Chcete nyní koláž uložit?',
        errorTitle: 'Něco se pokazilo.',
        errorMessage: 'Došlo k technickému problému. Opakujte akci nebo se obraťte na naši službu podpory.',
        showMore: 'Zobrazit více',
        showLess: 'Zobrazit méně',
        noProductsInBasket: 'Vyberte alespoň jeden výrobek, který přidáte do košíku.',
        removeTitle: 'Smazat koláž.',
        removePromt: 'Opravdu chcete koláž smazat?',
        couldNotRemove: 'Nelze odstranit. Opakujte akci nebo se obraťte na naši službu podpory.',
        remove: 'Odstranit',
        removeFrame: 'Smazat rám',
        close: 'Zavřít',
        wantToContinue: 'Chcete pokračovat?',
        unsavedChanges: 'Provedli jste změny, které nebyly uloženy. Chcete nyní koláž uložit?',
        needsArticlesShare: 'Před sdílením přidejte alespoň jednu položku.',
        needsArticlesSave: 'Před uložením přidejte alespoň jednu položku.',
        needsPictureWall: 'Vyberte koláž, než vyberete položky.',
        menu: 'Nabídka',
        noMotivs: 'Nevybrali jste žádné návrhy.',
        leavingSave: 'Koláž jste neuložili. Opravdu chcete odejít?',
        addedToCartDate: 'Přidáno do košíku {datum}',
        saveAndMoveOn: 'Další krok',
        moveOn: 'Další krok',
        saveAndClose: 'Uložit a zavřít',
        backgrounds: '1. Vybrat pozadí',
        pictureWalls: '2. Vybrat koláž',
        yourMotifs: '3. Vybrat návrhy',
        frames: '4. Orámuj si svůj design',
        leftToFreeShipping: 'Potřebné pro dopravu zdarma',
        checkout: 'Pokladna',
        total: 'Celková částka',
        emptyBasket: 'Do košíku jste nepřidali žádné produkty.',
        allProducts: 'Všechny produkty',
        lastViewed: 'Naposledy zobrazeno',
        myFavorites: 'Oblíbené položky',
        lastChosen: 'Naposledy vybrané',
        choosePictureWallBeforeFrames: 'Vyberte koláž, než vyberete rámečky.',
        dontSave: "neukládat",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tipy ',
        heartInfo: 'Klepnutím na symbol srdce uložte oblíbené položky. <br/> Zobrazí oblíbené položky v rozevíracím seznamu vlevo.',
        purchaseNowTitle: 'To vypadá skvěle!',
        purchaseNow: 'Do košíku můžete přidat celou svou koláž.',
        addToCart: 'Přidat do',
        addToCartSmall: 'Přidat do',
        toCheckout: 'Pokladna',
        savedWalls: 'Uložit koláže.',
        goBackToStep: 'Předchozí krok',
        favoritesThatMatch: 'Dostupné oblíbené položky ve vybrané velikosti',
        favoritesThatMatchMobile: 'Oblíbené položky ve vybrané velikosti',
        noStock: 'Některé položky nejsou na skladě.',

        startTop: 'Krok za krokem',
        startTitle: 'Vytvoření perfektní nástěnné galerie.',
        startText: 'Použijte náš nový nástroj k vyhledání návrhů a rámů, které k sobě ladí.',
        startButton: 'ZAČNĚTE ZDE',
        clickFullscreen: 'Kliknutím zobrazíte celou obrazovku.',

        noArticlesMatched: 'Lituji, ale nemůžeme najít žádné produkty (o velikosti), které by odpovídaly vašemu vyhledávání.',
        breadcrumbPrints: 'PLAKÁTECH',
        breadcrumbInsp: 'INSPIRACE',
        breadcrumbInspLink: 'https://desenio.cz/g/nastenne-galerie/',
        breadcrumbGw: 'Vytvořte si vlastní nástěnnou galerii',
        breadcrumbGwLink: 'https://gwt.desenio.cz/#/',

        linkToWall: 'ODKAZ NA VAŠÍ NÁSTĚNNOU GALERII',
        copy: 'Kopírovat',

        outOfStock: 'Není skladem',
        outOfStockText: 'Níže uvedené položky nejsou skladem, můžete je sledovat, abyste byli informováni, až budou opět skladem.',

        checkoutUrl: 'https://checkout.desenio.cz',
        pageUrl: 'https://desenio.cz',

    },
    sk: {
        countryCode: 'SK',
        yes: 'áno',
        no: 'nie',
        abort: 'zrušiť',
        my: 'môj',
        done: 'hotovo',
        pick: 'vybrať',
        save: 'uložiť',
        share: 'zdieľať',
        buy: 'kúpiť',
        addToCart: 'Pridať do',
        name: 'Názov',
        currencySuffix: ' ',
        currencySuffixBuy: ' €',
        currencyPrefix: '',
        frameYourMotifs: 'Zarámujte si motívy',
        background: 'pozadie | pozadia',
        picturewall: 'obrazová stena | obrazové steny',
        backgroundColor: 'farba pozadia | farby pozadia',
        color: 'farba | farby',
        motifs: 'dizajn | dizajny',
        clear: 'Vymazať',
        filter: 'Filter',
        showFilter: 'Zobraziť filter',
        hideFilter: 'Skryť filter',
        clearFilter: 'Vymazať filter',
        category: 'Kategória',
        allArticles: 'Všetko',
        articles: 'Položky',
        clickToPickMotif: 'Kliknite na obrázok z obrazovej steny, aby ste si vybrali motív.',
        clickToPickWall: 'Vyberte si obrazovú stenu predtým, ako si vyberiete motívy',
        turnDevice: 'Zapnite zariadenie',
        swipeUp: 'Potiahnite nahor',
        waresAddedToCart: 'Položky, ktoré ste si vybrali, boli pridané do košíka',
        proceedingToCheckout: 'Prejsť k platbe',
        saveBasket: 'Uložiť obrazovú stenu',
        noSavedWalls: 'Neuložili ste  žiadnu obrazovú stenu',
        updateOrnew: 'Vybrali ste si uloženú obrazovú stenu {názov}. Chceli by ste aktualizovať stenu alebo vytvoriť novú? ',
        createNew: 'vytvoriť novú',
        update: 'aktualizovať',
        shareTitle: 'Zdieľať obrazovú stenu',
        shareSaveTitle: 'Najprv ju, prosím, uložte',
        shareSaveText: 'Pred zdieľaním obrazovej steny ju musíte najprv uložiť. Chcete ju uložiť teraz?',
        errorTitle: 'Chyba.',
        errorMessage: 'Vyskytol sa technický problém. Skúste to znova alebo kontaktujte našu technickú podporu.',
        showMore: 'Zobraziť viac',
        showLess: 'Zobraziť menej',
        noProductsInBasket: 'Vyberte, prosím, aspoň jeden produkt do košíka.',
        removeTitle: 'Odstrániť obrazovú stenu',
        removePromt: 'Ste si istý, že chcete odstrániť obrazovú stenu?',
        couldNotRemove: 'Odstránenie nebolo možné. Vyskúšajte to, prosím, znova, alebo kontaktujte našu technickú podporu.',
        remove: 'Odstrániť',
        removeFrame: 'Odstrániť rám',
        close: 'Zatvoriť',
        wantToContinue: 'Chcete pokračovať?',
        unsavedChanges: 'Urobili ste zmeny, ktoré neboli uložené. Chcete uložiť obrazovú stenu teraz?',
        needsArticlesShare: 'Pred zdieľaním pridajte, prosím, aspoň jednu položku.',
        needsArticlesSave: 'Pred uložením pridajte, prosím, aspoň jednu položku.',
        needsPictureWall: 'Pred vybraním položiek, prosím, vyberte obrazovú stenu.',
        menu: 'Menu',
        noMotivs: 'Nevybrali ste žiadny motív',
        leavingSave: 'Neuložili ste obrazovú stenu. Ste si istý, že chcete odísť?',
        addedToCartDate: 'Pridané do košíka {dátum}',
        saveAndMoveOn: 'Ďalší krok',
        moveOn: 'Ďalší krok',
        saveAndClose: 'Uložiť a zavrieť',
        backgrounds: '1. Zvoliť pozadie',
        pictureWalls: '2. Zvoliť obrazovú stenu',
        yourMotifs: '3. Zvoliť motívy',
        frames: '4. Zarámovať motívy',
        leftToFreeShipping: 'Pre poštovné zdarma',
        checkout: 'K platbe',
        total: 'celková suma',
        emptyBasket: 'Nepridali ste žiadne položky do košíka.',
        allProducts: 'Všetky produkty',
        lastViewed: 'Posledné zobrazené',
        myFavorites: 'Moje obľúbené',
        lastChosen: 'Posledné vybrané',
        choosePictureWallBeforeFrames: 'Pred výberom rámov si, prosím, vyberte obrazovú stenu.',
        dontSave: "neukladať",
        heartInfoTitle: '<i class="fa fa-heart-o"></i> Tipy ',
        heartInfo: 'Kliknite na srdce, aby ste uložili svoje obľúbené kúsky. <br/> Zobraziť obľúbené kúsky v rozbaľovacom zozname vľavo.',
        purchaseNowTitle: 'Toto vyzerá skvele!',
        purchaseNow: 'Tu môžete pridať celú obrazovú stenu do košíka.',
        addToCart: 'Pridať do',
        addToCartSmall: 'Pridať do',
        toCheckout: 'K platbe',
        savedWalls: 'Uložiť obrazové steny',
        goBackToStep: 'Predošlý krok',
        favoritesThatMatch: 'Obľúbené kúsky k dispozícii vo vybranej veľkosti',
        favoritesThatMatchMobile: 'Obľúbené kúsky vo vybranej veľkosti',
        noStock: 'Niektoré položky nie sú na sklade.',

        startTop: 'Krok za krokom',
        startTitle: 'Vytvorte dokonalú obrazovú stenu',
        startText: 'Použite náš nový nástroj na vyhľadanie motívov a rámov, ktoré sa k sebe hodia',
        startButton: 'ZAČNITE TU',
        clickFullscreen: 'Kliknite na zobrazenie celej obrazovky',

        noArticlesMatched: 'Ľutujeme, nepodarilo sa nájsť žiadne produkty vo veľkosti (veľkosť), ktoré zodpovedajú vášmu vyhľadávaniu.',
        breadcrumbPrints: 'PLAGÁTY',
        breadcrumbInsp: 'INŠPIRÁCIA',
        breadcrumbInspLink: 'https://desenio.sk/g/zostavy-obrazov/',
        breadcrumbGw: 'Vytvorte si obrazovú stenu',
        breadcrumbGwLink: 'https://gwt.desenio.sk/',

        linkToWall: 'ODKAZ NA VAŠU ZOSTAVU OBRAZOV',
        copy: 'Kopírovať',

        outOfStock: 'Ni na zalogi',
        outOfStockText: 'Spodnjih izdelkov ni na zalogi, lahko jih spremljate in boste obveščeni, ko bodo spet na zalogi.',

        checkoutUrl: 'https://checkout.desenio.sk',
        pageUrl: 'https://desenio.sk',

    },
    el: {
      countryCode: 'EL',
      yes: 'ναι',
      no: 'όχι',
      abort: 'ακύρωση',
      my: 'τα',
      done: 'ολοκληρώθηκε',
      pick: 'επιλογή',
      save: 'αποθήκευση',
      share: 'μοιραστείτε',
      buy: 'αγορά',
      addToCart: 'προσθήκη σε',
      name: 'Όνομα',
      currencySuffix: '',
      currencySuffixBuy: '',
      currencyPrefix: '€',
      frameYourMotifs: 'Καδράρετε τα poster σας',
      background: 'φόντου | φόντα',
      picturewall: 'σύνθεσης gallery wall | συνθέσεις gallery wall',
      backgroundColor: 'χρώμα φόντου | χρώματα φόντου',
      color: 'χρώμα | χρώματα',
      motifs: 'poster | poster',
      clear: 'Εκκαθάριση',
      filter: 'Φίλτρο',
      showFilter: 'Εμφάνιση φίλτρου',
      hideFilter: 'Απόκρυψη φίλτρου',
      clearFilter: 'Απαλοιφή φίλτρου',
      category: 'Κατηγορία',
      allArticles: 'Όλα',
      articles: 'προϊόντα',
      clickToPickMotif: 'Κάντε κλικ σε μια εικόνα στο gallery wall για να επιλέξετε ένα poster.',
      clickToPickWall: 'Επιλέξτε μία σύνθεση gallery wall πριν επιλέξετε σχέδια',
      turnDevice: 'Περιστρέψτε τη συσκευή σας',
      swipeUp: 'Swipe up',
      waresAddedToCart: 'Τα προϊόντα έχουν προστεθεί στο καλάθι σας',
      proceedingToCheckout: 'Προχωρήστε στην ολοκλήρωση της αγοράς',
      saveBasket: 'Αποθήκευση gallery wall',
      noSavedWalls: 'Δεν υπάρχουν αποθηκευμένα gallery wall',
      updateOrnew: 'Επιλέξατε ένα αποθηκευμένο gallery wall {name}. Θέλετε να ενημερώσετε τον τοίχο σας ή να δημιουργήσετε έναν νέο; ',
      createNew: 'δημιουργία νέου',
      update: 'ενημέρωση',
      shareTitle: 'Μοιραστείτε το gallery wall',
      shareSaveTitle: 'Παρακαλούμε αποθηκεύστε πρώτα',
      shareSaveText: 'Πρέπει να αποθηκεύσετε το gallery wall για να μπορέσετε να το μοιραστείτε. Θέλετε να αποθηκεύσετε το gallery wall σας τώρα;',
      errorTitle: 'Κάτι πήγε στραβά.',
      errorMessage: 'Παρουσιάστηκε ένα τεχνικό πρόβλημα. Προσπαθήστε ξανά ή επικοινωνήστε με την υπηρεσία υποστήριξης.',
      showMore: 'Εμφάνιση περισσότερων',
      showLess: 'Εμφάνιση λιγότερων',
      noProductsInBasket: 'Επιλέξτε τουλάχιστον ένα προϊόν για προσθήκη στο καλάθι σας.',
      removeTitle: 'Διαγραφή gallery wall',
      removePromt: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το gallery wall;',
      couldNotRemove: 'Δεν είναι δυνατή η διαγραφή. Προσπαθήστε ξανά ή επικοινωνήστε με την υπηρεσία υποστήριξης.',
      remove: 'Διαγραφή',
      removeFrame: 'Διαγραφή κορνίζας',
      close: 'Κλείσιμο',
      wantToContinue: 'Θέλετε να συνεχίσετε;',
      unsavedChanges: 'Έχετε κάνει αλλαγές που δεν έχουν αποθηκευτεί. Θέλετε να αποθηκεύσετε το gallery wall σας τώρα;',
      needsArticlesShare: 'Προσθέστε τουλάχιστον ένα προϊόν πριν το μοιραστείτε.',
      needsArticlesSave: 'Προσθέστε τουλάχιστον ένα προϊόν πριν την αποθήκευση.',
      needsPictureWall: 'Επιλέξτε ένα gallery wall πριν επιλέξετε προϊόντα.',
      menu: 'Μενού',
      noMotivs: 'Δεν έχετε επιλέξει poster',
      leavingSave: 'Δεν αποθηκεύσατε το gallery wall σας. Είστε σίγουροι ότι θέλετε να φύγετε;',
      addedToCartDate: 'Προστέθηκε στο καλάθι {date}',
      saveAndMoveOn: 'Επόμενο',
      moveOn: 'Επόμενο',
      saveAndClose: 'Αποθήκευση και κλείσιμο',
      backgrounds: '1. Επιλογή φόντου',
      pictureWalls: '2. Επιλογή gallery wall',
      yourMotifs: '3. Επιλογή poster',
      frames: '4. Καδράρετε τα poster σας',
      leftToFreeShipping: 'Απαιτείται για δωρεάν αποστολή',
      checkout: 'Πληρωμή',
      total: 'συνολικό ποσό',
      emptyBasket: 'Δεν έχετε προσθέσει προϊόντα στο καλάθι σας.',
      allProducts: 'Όλα τα προϊόντα',
      lastViewed: 'Τελευταία προβολή',
      myFavorites: 'Τα αγαπημένα μου',
      lastChosen: 'Τελευταίες επιλογές',
      choosePictureWallBeforeFrames: 'Επιλέξτε ένα gallery wall πριν επιλέξετε κορνίζες.',
      dontSave: "Χωρίς αποθήκευση",
      heartInfoTitle: '<i class="fa fa-heart-o"></i> Tips ',
      heartInfo: 'Κάντε κλικ στο σύμβολο της καρδιάς για να αποθηκεύσετε τα αγαπημένα σας.<br/> Εμφάνιση αγαπημένων στην αναπτυσσόμενη λίστα στα αριστερά.',
      purchaseNowTitle: 'Αυτό φαίνεται υπέροχο!',
      purchaseNow: 'Μπορείτε να προσθέσετε ολόκληρο το gallery wall στο καλάθι σας εδώ.',
      addToCart: 'Προσθήκη σε',
      addToCartSmall: 'Προσθήκη σε',
      toCheckout: 'Πληρωμή',
      savedWalls: 'Αποθηκευμένα gallery wall',
      goBackToStep: 'ΠΡΟΗΓΟΥΜΕΝΟ',
      favoritesThatMatch: 'Αγαπημένα διαθέσιμα στο επιλεγμένο μέγεθος',
      favoritesThatMatchMobile: 'Αγαπημένα στο επιλεγμένο μέγεθος',
      noStock: 'Ορισμένα προϊόντα είναι εκτός αποθέματος.',
      startTop: 'Βήμα προς βήμα',
      startTitle: 'Δημιουργήστε το τέλειο gallery wall',
      startText: 'Χρησιμοποιήστε το νέο μας εργαλείο για να βρείτε poster και κορνίζες που ταιριάζουν μεταξύ τους',
      startButton: 'ΞΕΚΙΝΗΣΤΕ ΕΔΩ',
      clickFullscreen: 'Κάντε κλικ για πλήρη οθόνη',
      noArticlesMatched: "Λυπούμαστε, δεν μπορούμε να βρούμε προϊόντα σε (size) που να ταιριάζουν με την αναζήτησή σας.",
      breadcrumbPrints: 'Posters',
      breadcrumbInsp: 'Έμπνευση',
      breadcrumbInspLink: 'https://desenio.es/g/galerias-de-pared/',
      breadcrumbGw: 'Δημιουργήστε το gallery wall σας',
      breadcrumbGwLink: 'https://desenio.gr/g/gallery-wall/',
      linkToWall: 'Ο ΣΥΝΔΕΣΜΟΣ ΤΟΥ GALLERY WALL ΣΑΣ',
      copy: 'Αντιγραφή',

      outOfStock: 'Δεν υπάρχει απόθεμα',
      outOfStockText: 'Τα παρακάτω είδη δεν υπάρχουν σε απόθεμα, μπορείτε να τα παρακολουθήσετε για να ειδοποιηθείτε όταν επανέλθουν σε απόθεμα.',

      checkoutUrl: 'https://checkout.desenio.gr',
      pageUrl: 'https://desenio.gr',

  }
}

// Clone UK to US
messages['us'] = _.cloneDeep(messages["en"]);
messages['us']['countryCode'] = 'US';
messages['us']['currencyPrefix'] = '';
messages['us']['currencySuffix'] = ' USD';
messages['us']['currencySuffixBuy'] = ' USD';
messages['us']['breadcrumbPrints'] = 'Wall art';
messages['us']['breadcrumbInsp'] = 'INSPIRATION';
messages['us']['breadcrumbInspLink'] = '/us/gallery-walls';
messages['us']['breadcrumbGw'] = 'Create your gallery wall';
messages['us']['breadcrumbGwLink'] = 'https://gwt.desenio.com/';

messages['us']['checkoutUrl'] = 'https://checkout.desenio.com';
messages['us']['pageUrl'] = 'https://desenio.com';

//ESUS
messages['esus'] = _.cloneDeep(messages["es"]);
messages['esus']['countryCode'] = 'ESUS';
messages['esus']['currencyPrefix'] = '';
messages['esus']['currencySuffix'] = ' &dollar;';
messages['esus']['currencySuffixBuy'] = ' &dollar;';
messages['esus']['breadcrumbPrints'] = 'Cuadros';
messages['esus']['breadcrumbInsp'] = 'INSPIRACIÓN';
messages['esus']['breadcrumbGw'] = 'Crea tu decoración de pared';
messages['esus']['breadcrumbInspLink'] = '/es-us/g/galerias-de-pared/';
messages['esus']['breadcrumbGwLink'] = 'https://es-gwt.desenio.com/';

messages['esus']['checkoutUrl'] = 'https://es-checkout.desenio.com';
messages['esus']['pageUrl'] = 'https://desenio.com/es-us/';

// Subdomains
// DEAT
messages['deat'] = _.cloneDeep(messages["de"]);
messages['deat']['countryCode'] = 'DEAT';
messages['deat']['breadcrumbPrints'] = 'Wanbilder';
messages['deat']['breadcrumbInsp'] = 'INSPIRATION';
messages['deat']['breadcrumbInspLink'] = '/at/bilderwand-inspiration-posters';
messages['deat']['breadcrumbGw'] = 'Komponiere deine Bilderwand';
messages['deat']['breadcrumbGwLink'] = '/at/ak/inspiration/komponiere-deine-bilderwand-deat';

messages['deat']['checkoutUrl'] = 'https://checkout.desenio.at';
messages['deat']['pageUrl'] = 'https://desenio.at';

// ENAU
messages['enau'] = _.cloneDeep(messages["en"]);
messages['enau']['countryCode'] = 'ENAU';
messages['enau']['currencyPrefix'] = '';
messages['enau']['currencySuffix'] = ' &dollar;';
messages['enau']['currencySuffixBuy'] = ' &dollar;';
messages['enau']['breadcrumbPrints'] = 'Wall art';
messages['enau']['breadcrumbInsp'] = 'INSPIRATION';
messages['enau']['breadcrumbInspLink'] = '/au/inspiration';
messages['enau']['breadcrumbGw'] = 'Create your gallery wall';
messages['enau']['breadcrumbGwLink'] = '/au/ak/inspiration/create-your-gallery-wall';

messages['enau']['checkoutUrl'] = 'https://checkout.desenio.com.au';
messages['enau']['pageUrl'] = 'https://desenio.com.au';

//ca
messages['ca'] = _.cloneDeep(messages["en"]);
messages['ca']['countryCode'] = 'CA';
messages['ca']['currencyPrefix'] = '';
messages['ca']['currencySuffix'] = ' &dollar;';
messages['ca']['currencySuffixBuy'] = ' &dollar;';
messages['ca']['breadcrumbPrints'] = 'Wall art';
messages['ca']['breadcrumbInsp'] = 'INSPIRATION';
messages['ca']['breadcrumbInspLink'] = '/g/gallery-walls';
messages['ca']['breadcrumbGw'] = 'Create your gallery wall';
messages['ca']['breadcrumbGwLink'] = 'https://gwt.desenio.ca/';

messages['ca']['checkoutUrl'] = 'https://checkout.desenio.ca';
messages['ca']['pageUrl'] = 'https://desenio.ca/';

//FRCA
messages['frca'] = _.cloneDeep(messages["fr"]);
messages['frca']['countryCode'] = 'FRCA';
messages['frca']['currencyPrefix'] = '';
messages['frca']['currencySuffix'] = ' &dollar;';
messages['frca']['currencySuffixBuy'] = ' &dollar;';
messages['frca']['breadcrumbPrints'] = 'Tableaux';
messages['frca']['breadcrumbInsp'] = 'INSPIRATION';
messages['frca']['breadcrumbInspLink'] = '/fr-ca/g/decoration-murale';
messages['frca']['breadcrumbGw'] = 'Créez votre mur de cadres';
messages['frca']['breadcrumbGwLink'] = 'https://fr-gwt.desenio.ca/';

messages['frca']['checkoutUrl'] = 'https://fr-checkout.desenio.ca';
messages['frca']['pageUrl'] = 'https://desenio.ca/fr-ca/';

// DEBE
messages['debe'] = _.cloneDeep(messages["de"]);
messages['debe']['countryCode'] = 'DEBE';
messages['debe']['breadcrumbPrints'] = 'Wanbilder';
messages['debe']['breadcrumbInsp'] = 'INSPIRATION';
messages['debe']['breadcrumbInspLink'] = '/be/de/bilderwand-inspiration-posters';
messages['debe']['breadcrumbGw'] = 'Komponiere deine Bilderwand';
messages['debe']['breadcrumbGwLink'] = '/debe/ak/inspiration/komponiere-deine-bilderwand-debe';

messages['debe']['checkoutUrl'] = 'https://de-checkout.desenio.be';
messages['debe']['pageUrl'] = 'https://desenio.be/de-be/';

// FRBE
messages['frbe'] = _.cloneDeep(messages["fr"]);
messages['frbe']['countryCode'] = 'FRBE';
messages['frbe']['breadcrumbPrints'] = 'Tableaux';
messages['frbe']['breadcrumbInsp'] = 'INSPIRATION';
messages['frbe']['breadcrumbInspLink'] = '/be/fr/inspiration';
messages['frbe']['breadcrumbGw'] = 'Créez votre mur de cadres';
messages['frbe']['breadcrumbGwLink'] = '/frbe/ak/inspiration/creez-votre-mur-de-tableaux-frbe';

messages['frbe']['checkoutUrl'] = 'https://fr-checkout.desenio.be';
messages['frbe']['pageUrl'] = 'https://desenio.be/fr-be/';

// NLBE
messages['nlbe'] = _.cloneDeep(messages["nl"]);
messages['nlbe']['countryCode'] = 'NLBE';
messages['nlbe']['breadcrumbPrints'] = 'Posters';
messages['nlbe']['breadcrumbInsp'] = 'INSPIRATIE';
messages['nlbe']['breadcrumbInspLink'] = '/be/nl/inspiratie-poster';
messages['nlbe']['breadcrumbGw'] = 'Stel uw fotowand samen';
messages['nlbe']['breadcrumbGwLink'] = '/nlbe/ak/inspiration/stel-uw-fotowand-samen-nlbe';

messages['nlbe']['checkoutUrl'] = 'https://nl-checkout.desenio.be';
messages['nlbe']['pageUrl'] = 'https://desenio.be/nl-be/';

// DECH
messages['dech'] = _.cloneDeep(messages["de"]);
messages['dech']['countryCode'] = 'DECH';
messages['dech']['currencyPrefix'] = '';
messages['dech']['currencySuffix'] = ' CHF';
messages['dech']['currencySuffixBuy'] = ' CHF';
messages['dech']['breadcrumbPrints'] = 'Wanbilder';
messages['dech']['breadcrumbInsp'] = 'INSPIRATION';
messages['dech']['breadcrumbInspLink'] = '/ch/de/bilderwand-inspiration-posters';
messages['dech']['breadcrumbGw'] = 'Komponiere deine Bilderwand';
messages['dech']['breadcrumbGwLink'] = '/dech/ak/inspiration/komponiere-deine-bilderwand-dech';

messages['dech']['checkoutUrl'] = 'https://de-checkout.desenio.ch';
messages['dech']['pageUrl'] = 'https://desenio.ch/de-ch/';

// FRCH
messages['frch'] = _.cloneDeep(messages["fr"]);
messages['frch']['countryCode'] = 'FRCH';
messages['frch']['currencyPrefix'] = '';
messages['frch']['currencySuffix'] = ' CHF';
messages['frch']['currencySuffixBuy'] = ' CHF';
messages['frch']['breadcrumbPrints'] = 'Tableaux';
messages['frch']['breadcrumbInsp'] = 'INSPIRATION';
messages['frch']['breadcrumbInspLink'] = '/ch/fr/inspiration';
messages['frch']['breadcrumbGw'] = 'Créez votre mur de cadres';
messages['frch']['breadcrumbGwLink'] = '/frch/ak/inspiration/creez-votre-mur-de-tableaux';

messages['frch']['checkoutUrl'] = 'https://fr-checkout.desenio.ch';
messages['frch']['pageUrl'] = 'https://desenio.ch/fr-ch/';

// ITCH
messages['itch'] = _.cloneDeep(messages["it"]);
messages['itch']['countryCode'] = 'ITCH';
messages['itch']['currencyPrefix'] = '';
messages['itch']['currencySuffix'] = ' CHF';
messages['itch']['currencySuffixBuy'] = ' CHF';
messages['itch']['breadcrumbPrints'] = 'Quadri';
messages['itch']['breadcrumbInsp'] = 'ISPIRAZIONE';
messages['itch']['breadcrumbInspLink'] = '/ch/it/ispirazione';
messages['itch']['breadcrumbGw'] = 'Crea la tua galleria a parete';
messages['itch']['breadcrumbGwLink'] = '/itch/ak/inspiration/crea-la-tua-galleria-a-parete';

messages['itch']['checkoutUrl'] = 'https://it-checkout.desenio.ch';
messages['frch']['pageUrl'] = 'https://desenio.ch/it-ch/';

// ENIE
messages['enie'] = _.cloneDeep(messages["en"]);
messages['enie']['countryCode'] = 'ENIE';
messages['enie']['currencyPrefix'] = '';
messages['enie']['currencySuffix'] = ' €';
messages['enie']['currencySuffixBuy'] = ' €';
messages['enie']['breadcrumbInsp'] = 'Gallery Walls';
messages['enie']['breadcrumbInspLink'] = 'https://desenio.ie/g/gallery-walls';
messages['enie']['breadcrumbGwLink'] = 'https://gwt.desenio.ie';

messages['enie']['checkoutUrl'] = 'https://checkout.desenio.ie';
messages['enie']['pageUrl'] = 'https://desenio.ie';

if (typeof window.currentLang == 'undefined')
    window.currentLang = "en";

// Create VueI18n instance with options
export default new VueI18n({
    locale: window.currentLang, // set locale
    messages, // set locale messages
})



// WEBPACK FOOTER //
// ./client/language/index.js